// Homepage, ToolShowcase, WhyRupeeVikas, TrustStats, ExploreTools translations

export const homePageTranslations: Record<string, Record<string, string>> = {
  en: {
    "home.toolkitTitle": "Your Complete Financial Toolkit",
    "home.toolkitSub": "12 powerful tools built for the modern Indian earner — from your first SIP to your retirement corpus.",
    "home.catInvest": "💰 Invest & Grow",
    "home.catPlan": "🏠 Plan & Protect",
    "home.catTax": "📋 Tax & Debt",
    "home.catLife": "🎯 Life & Family",
    "home.toolWealth": "Investment Tools",
    "home.toolWealthDesc": "Calculate how your SIP or lump sum grows over time with the power of compounding.",
    "home.toolStock": "Stock Research Lab",
    "home.toolStockDesc": "Check live stock prices, company details, and charts — all in one place.",
    "home.toolMultiAsset": "Multi-Asset Comparison",
    "home.toolMultiAssetDesc": "See how FD, Gold, Index Funds, and Stocks perform side by side.",
    "home.toolRealEstate": "Real Estate Planner",
    "home.toolRealEstateDesc": "Find out the true cost of buying a home — EMI, stamp duty, and hidden charges.",
    "home.toolRentBuy": "Rent vs Buy Analyzer",
    "home.toolRentBuyDesc": "Should you rent or buy? Compare wealth outcomes over 20 years.",
    "home.toolRetirement": "Retirement Clock",
    "home.toolRetirementDesc": "Know how much you need to retire comfortably and the SIP to get there.",
    "home.toolTaxSim": "Tax Planner",
    "home.toolTaxSimDesc": "Compare Old vs New tax regime and find out which one saves you more.",
    "home.toolDebt": "Debt-Free Path",
    "home.toolDebtDesc": "Pick the fastest strategy to pay off your loans and save on interest.",
    "home.toolCreditCard": "Credit Card Master",
    "home.toolCreditCardDesc": "Understand your credit card costs, rewards, and impact on your credit score.",
    "home.toolInflation": "Inflation Reality Machine",
    "home.toolInflationDesc": "See how rising prices silently reduce what your money can buy over time.",
    "home.toolChildFuture": "Child's Future Planner",
    "home.toolChildFutureDesc": "Plan the monthly savings needed for your child's education goals.",
    "home.toolEMI": "Can I Buy It?",
    "home.toolEmergency": "Emergency Fund Planner",
    "home.toolEmergencyDesc": "Find out how much safety net you need based on your lifestyle and dependents.",
    "home.toolEMIDesc": "Check if you can truly afford a purchase — cash vs EMI with all hidden costs.",
    "hero.journeyTitle": "Start Your Investment Journey Today",
    "hero.journeyDesc": "Click here to begin — answer a few simple questions about your finances, and get a personalized dashboard to track your wealth, assets, liabilities, and tax obligations based on your profession.",
    "hero.journeyCta": "Click Here to Get Started →",
    "home.viewAllTools": "View All Tools",
    "home.whyTitle": "Why 'Sathi' Means More Than a Tool",
    "home.whySub": "RupeeVikas isn't just a calculator — it's your financial companion that speaks your language and understands Indian money.",
    "home.whyFreeTitle": "100% Free & Private",
    "home.whyFreeDesc": "No sign-up required for tools. Your data stays on your device — we never sell or share it.",
    "home.whyLangTitle": "13 Indian Languages",
    "home.whyLangDesc": "From Hindi to Kannada, Tamil to Assamese — financial literacy shouldn't have a language barrier.",
    "home.whyIndiaTitle": "Built for India",
    "home.whyIndiaDesc": "Indian tax regimes, SEBI regulations, RBI rates, and UPI-era debt management — not imported templates.",
    "home.whySathiTitle": "Sathi Intelligence",
    "home.whySathiDesc": "Every tool comes with contextual tips and insights — like having a financially-savvy friend by your side.",
    "home.statTools": "Financial Tools",
    "home.statLangs": "Indian Languages",
    "home.statFree": "Forever Free",
    "home.statPrivacy": "Privacy First",
    "home.footerDisclaimer2": "Data provided is for educational use only. All interest rates and tax laws are updated as of March 2026. Consult a certified financial professional before making investment decisions. RupeeVikas does not provide personalized financial advice.",
    "home.footerIndian": "🇮🇳 100% Indian-owned — focused on Indian Tax Regimes, Indian Real Estate laws, and UPI-based debt management.",
    "nav.stockResearch": "Stock Research",
    "explore.title": "Explore All Tools",
    "explore.subtitle": "Your complete financial toolkit — calculators, planners, and comparison engines",
    "explore.openTool": "Open Tool",
    "explore.toolCalc": "Investment Calculators",
    "explore.toolCalcDesc": "SIP, Lump Sum, and more investment calculators",
    "explore.toolDebt": "Debt-Free Path",
    "explore.toolDebtDesc": "Snowball vs Avalanche strategies to crush your debt faster",
    "explore.toolTaxSim": "Tax Planner",
    "explore.toolTaxSimDesc": "Simulate your tax liability under Old vs New regime",
    "explore.toolRealEstate": "Real Estate Planner",
    "explore.toolRealEstateDesc": "Budget, ROI simulator, and affordability check",
    "explore.toolRentBuy": "Rent vs Buy Analyzer",
    "explore.toolRentBuyDesc": "Compare renting vs buying with 15-year wealth projection",
    "explore.toolRetirement": "Retirement Clock",
    "explore.toolRetirementDesc": "Plan your retirement corpus and monthly SIP needed",
    "explore.toolCompare": "Product Comparison",
    "explore.toolCompareDesc": "Compare credit cards, savings accounts & health insurance",
    "explore.toolEMI": "Affordability & EMI Mentor",
    "explore.toolEMIDesc": "Can you really afford it? Compare cash vs EMI with hidden costs",
    "explore.toolInflation": "Inflation Reality Machine",
    "explore.toolInflationDesc": "See how inflation silently eats your savings — with milk packet math",
    "explore.toolEmergency": "Emergency Fund Tester",
    "explore.toolEmergencyDesc": "Quiz-based stress test to calculate your ideal safety net",
    "explore.toolChildFuture": "Child's Future Planner",
    "explore.toolChildFutureDesc": "Reverse-engineer the SIP needed for your child's education dream",
    "explore.toolCreditCard": "Credit Card Master",
    "explore.toolCreditCardDesc": "Debt trap simulator, CIBIL predictor & true reward calculator",
    "explore.toolMultiAsset": "Multi-Asset Comparison",
    "explore.toolMultiAssetDesc": "Compare FD, Gold, Real Estate, Index Funds & Stock returns side by side",
    "explore.toolStock": "Stock Research Lab",
    "explore.toolStockDesc": "Live market data, company fundamentals & TradingView charts",
    "comp.bestFor": "Best for:",
    "comp.frequentFlyers": "Frequent flyers",
    "comp.onlineShoppers": "Online shoppers",

    // Premium redesign keys
    "hero.premiumHeadline": "Are you becoming Richer or Poorer every day?",
    "hero.premiumSub": "Find out in 30 seconds. Your financial future, visualized.",
    "hero.wealthCardTitle": "Future Wealth Simulator",
    "hero.monthlySavings": "Monthly Savings",
    "hero.premiumCta": "Show My Path to Freedom",

    // Category filters
    "cat.all": "All Tools",
    "cat.debt": "Debt-Free Path",
    "cat.invest": "Invest & Grow",
    "cat.home": "Buy a Home",
    "cat.kids": "Plan for Kids",
    "cat.tax": "Save Tax",

    // Tool galaxy micro-copy
    "tool.wealth.title": "Investment Tools",
    "tool.wealth.micro": "How fast can your SIP grow? See compounding magic in action.",
    "tool.stock.title": "Stock Lab",
    "tool.stock.micro": "Is your favorite stock a trap? Live data, charts & fundamentals.",
    "tool.multiAsset.title": "Multi-Asset Compare",
    "tool.multiAsset.micro": "FD vs Gold vs Stocks vs Index — who wins over 10 years?",
    "tool.realEstate.title": "Real Estate Planner",
    "tool.realEstate.micro": "The true cost of your dream home — EMI, stamp duty & hidden charges.",
    "tool.rentBuy.title": "Rent vs Buy",
    "tool.rentBuy.micro": "Math behind your Dream Home. Should you rent or buy?",
    "tool.retirement.title": "Retirement Clock",
    "tool.retirement.micro": "How much do you need to retire? Find your magic number.",
    "tool.taxSim.title": "Tax Planner",
    "tool.taxSim.micro": "Old vs New regime — which saves you more? Find out instantly.",
    "tool.debt.title": "Debt-Free Path",
    "tool.debt.micro": "Stop paying interest, start living. Crush your loans faster.",
    "tool.creditCard.title": "Credit Card Master",
    "tool.creditCard.micro": "Debt trap simulator, CIBIL predictor & true reward calculator.",
    "tool.childFuture.title": "Child's Future",
    "tool.childFuture.micro": "Plan monthly savings for your child's education dreams.",
    "tool.canibuyit.title": "Can I Buy It?",
    "tool.canibuyit.micro": "Can you truly afford it? Cash vs EMI with all hidden costs.",
    "tool.emergency.title": "Emergency Fund",
    "tool.emergency.micro": "How much safety net do you really need? Find out now.",
    "tool.inflation.title": "Inflation Machine",
    "tool.inflation.micro": "Why ₹100 feels like ₹50. The silent thief of your wealth.",
    "tool.compare.title": "Product Compare",
    "tool.compare.micro": "Compare credit cards, savings accounts & insurance side by side.",

    // Contact section
    "contact.title": "Need Help? We're Here.",
    "contact.desc": "Questions, feedback, or just want to say hi? Reach out anytime.",

    // Bottom nav
    "nav.stockLab": "Stock Lab",
    "nav.goalTracker": "Goals",
    "nav.contact": "Contact",
    "nav.taxPlanner": "Tax Planner",
    "nav.propertyPlanner": "Property",
  },
  hi: {
    "home.toolkitTitle": "आपका संपूर्ण वित्तीय टूलकिट",
    "home.toolkitSub": "आधुनिक भारतीय कमाने वालों के लिए 12 शक्तिशाली टूल्स — आपकी पहली SIP से रिटायरमेंट कॉर्पस तक।",
    "home.catInvest": "💰 निवेश और विकास",
    "home.catPlan": "🏠 योजना और सुरक्षा",
    "home.catTax": "📋 टैक्स और कर्ज़",
    "home.catLife": "🎯 जीवन के चरण",
    "home.toolWealth": "वेल्थ इंजन",
    "home.toolWealthDesc": "जानें कि आपकी SIP या एकमुश्त राशि समय के साथ कंपाउंडिंग से कैसे बढ़ती है।",
    "home.toolStock": "स्टॉक रिसर्च लैब",
    "home.toolStockDesc": "लाइव स्टॉक प्राइस, कंपनी की जानकारी और चार्ट — सब एक जगह।",
    "home.toolMultiAsset": "मल्टी-एसेट तुलना",
    "home.toolMultiAssetDesc": "देखें FD, गोल्ड, इंडेक्स फंड और स्टॉक्स एक साथ कैसा प्रदर्शन करते हैं।",
    "home.toolRealEstate": "रियल एस्टेट प्लानर",
    "home.toolRealEstateDesc": "घर खरीदने की असली लागत जानें — EMI, स्टैम्प ड्यूटी और छुपे खर्चे।",
    "home.toolRentBuy": "किराया vs खरीद विश्लेषक",
    "home.toolRentBuyDesc": "किराया दें या खरीदें? 20 साल में संपत्ति के परिणामों की तुलना करें।",
    "home.toolRetirement": "रिटायरमेंट क्लॉक",
    "home.toolRetirementDesc": "जानें आरामदायक रिटायरमेंट के लिए कितना चाहिए और उसके लिए कितनी SIP करें।",
    "home.toolTaxSim": "टैक्स सिम्युलेटर",
    "home.toolTaxSimDesc": "पुरानी vs नई टैक्स रिजीम की तुलना करें और जानें कौन सी ज़्यादा बचाती है।",
    "home.toolDebt": "कर्ज-मुक्ति पथ",
    "home.toolDebtDesc": "लोन चुकाने की सबसे तेज़ रणनीति चुनें और ब्याज बचाएं।",
    "home.toolCreditCard": "क्रेडिट कार्ड मास्टर",
    "home.toolCreditCardDesc": "अपने क्रेडिट कार्ड की लागत, रिवॉर्ड और क्रेडिट स्कोर पर प्रभाव समझें।",
    "home.toolInflation": "महंगाई रियलिटी मशीन",
    "home.toolInflationDesc": "देखें कैसे बढ़ती कीमतें चुपचाप आपके पैसे की ताकत कम करती हैं।",
    "home.toolChildFuture": "बच्चे का भविष्य प्लानर",
    "home.toolChildFutureDesc": "बच्चे की पढ़ाई के लक्ष्य के लिए मासिक बचत की योजना बनाएं।",
    "home.toolEMI": "EMI मेंटर",
    "home.toolEMIDesc": "क्या आप वो खरीदारी वाकई कर सकते हैं? कैश vs EMI सभी छुपी लागतों सहित।",
    "hero.journeyTitle": "आज ही अपनी निवेश यात्रा शुरू करें",
    "hero.journeyDesc": "यहाँ क्लिक करें — अपने वित्त के बारे में कुछ सवालों के जवाब दें, और अपनी संपत्ति, एसेट, देनदारियाँ और पेशे के अनुसार टैक्स देनदारियों को ट्रैक करने के लिए व्यक्तिगत डैशबोर्ड पाएं।",
    "hero.journeyCta": "यहाँ क्लिक करें शुरू करने के लिए →",
    "home.viewAllTools": "सभी टूल्स देखें",
    "home.whyTitle": "'साथी' का मतलब सिर्फ एक टूल नहीं",
    "home.whySub": "RupeeVikas सिर्फ कैलकुलेटर नहीं — यह आपका वित्तीय साथी है जो आपकी भाषा बोलता है और भारतीय पैसे को समझता है।",
    "home.whyFreeTitle": "100% मुफ़्त और निजी",
    "home.whyFreeDesc": "टूल्स के लिए साइन-अप ज़रूरी नहीं। आपका डेटा आपके डिवाइस पर रहता है — हम कभी बेचते या शेयर नहीं करते।",
    "home.whyLangTitle": "13 भारतीय भाषाएँ",
    "home.whyLangDesc": "हिंदी से कन्नड़, तमिल से असमिया — वित्तीय साक्षरता में भाषा की बाधा नहीं होनी चाहिए।",
    "home.whyIndiaTitle": "भारत के लिए बना",
    "home.whyIndiaDesc": "भारतीय टैक्स रिजीम, SEBI नियम, RBI दरें, और UPI-युग ऋण प्रबंधन — आयातित टेम्पलेट नहीं।",
    "home.whySathiTitle": "साथी बुद्धिमत्ता",
    "home.whySathiDesc": "हर टूल के साथ संदर्भ-आधारित सुझाव — जैसे एक वित्तीय समझदार दोस्त आपके साथ हो।",
    "home.statTools": "वित्तीय टूल्स",
    "home.statLangs": "भारतीय भाषाएँ",
    "home.statFree": "हमेशा मुफ़्त",
    "home.statPrivacy": "गोपनीयता प्रथम",
    "home.footerDisclaimer2": "प्रदान किया गया डेटा केवल शैक्षिक उपयोग के लिए है। सभी ब्याज दरें और कर कानून मार्च 2026 तक अपडेट हैं। निवेश निर्णय लेने से पहले प्रमाणित वित्तीय पेशेवर से परामर्श करें।",
    "home.footerIndian": "🇮🇳 100% भारतीय-स्वामित्व — भारतीय टैक्स रिजीम, भारतीय रियल एस्टेट कानून, और UPI-आधारित ऋण प्रबंधन पर केंद्रित।",
    "nav.stockResearch": "स्टॉक रिसर्च",
    "explore.title": "सभी टूल्स एक्सप्लोर करें",
    "explore.subtitle": "आपकी संपूर्ण वित्तीय टूलकिट — कैलकुलेटर, प्लानर और तुलना इंजन",
    "explore.openTool": "टूल खोलें",
    "explore.toolCalc": "निवेश कैलकुलेटर",
    "explore.toolCalcDesc": "SIP, एकमुश्त, और अधिक निवेश कैलकुलेटर",
    "explore.toolDebt": "कर्ज-मुक्ति पथ",
    "explore.toolDebtDesc": "कर्ज़ तेज़ी से खत्म करने के लिए स्नोबॉल vs एवलांच रणनीतियाँ",
    "explore.toolTaxSim": "टैक्स सिम्युलेटर",
    "explore.toolTaxSimDesc": "पुरानी vs नई रिजीम में अपनी टैक्स देनदारी सिम्युलेट करें",
    "explore.toolRealEstate": "रियल एस्टेट प्लानर",
    "explore.toolRealEstateDesc": "बजट, ROI सिम्युलेटर, और सामर्थ्य जाँच",
    "explore.toolRentBuy": "किराया vs खरीद विश्लेषक",
    "explore.toolRentBuyDesc": "15 साल की संपत्ति प्रक्षेपण से किराया vs खरीद तुलना",
    "explore.toolRetirement": "रिटायरमेंट क्लॉक",
    "explore.toolRetirementDesc": "रिटायरमेंट कॉर्पस और मासिक SIP की योजना बनाएं",
    "explore.toolCompare": "उत्पाद तुलना",
    "explore.toolCompareDesc": "क्रेडिट कार्ड, बचत खाते और स्वास्थ्य बीमा की तुलना करें",
    "explore.toolEMI": "सामर्थ्य और EMI मेंटर",
    "explore.toolEMIDesc": "क्या आप वाकई कर सकते हैं? कैश vs EMI छुपी लागतों से तुलना",
    "explore.toolInflation": "महंगाई रियलिटी मशीन",
    "explore.toolInflationDesc": "देखें कैसे महंगाई चुपचाप आपकी बचत खाती है — दूध के पैकेट गणित से",
    "explore.toolEmergency": "इमरजेंसी फंड टेस्टर",
    "explore.toolEmergencyDesc": "आपका आदर्श सेफ्टी नेट कैलकुलेट करने के लिए क्विज़-आधारित स्ट्रेस टेस्ट",
    "explore.toolChildFuture": "बच्चे का भविष्य प्लानर",
    "explore.toolChildFutureDesc": "बच्चे की शिक्षा के सपने के लिए SIP रिवर्स-इंजीनियर करें",
    "explore.toolCreditCard": "क्रेडिट कार्ड मास्टर",
    "explore.toolCreditCardDesc": "कर्ज़ जाल सिम्युलेटर, CIBIL प्रेडिक्टर और ट्रू रिवॉर्ड कैलकुलेटर",
    "explore.toolMultiAsset": "मल्टी-एसेट तुलना",
    "explore.toolMultiAssetDesc": "FD, सोना, रियल एस्टेट, इंडेक्स फंड और स्टॉक रिटर्न की तुलना करें",
    "explore.toolStock": "स्टॉक रिसर्च लैब",
    "explore.toolStockDesc": "लाइव मार्केट डेटा, कंपनी फंडामेंटल्स और TradingView चार्ट",
    "comp.bestFor": "सबसे अच्छा:",
    "comp.frequentFlyers": "बार-बार उड़ने वालों के लिए",
    "comp.onlineShoppers": "ऑनलाइन शॉपर्स के लिए",
    // Premium redesign keys
    "hero.premiumHeadline": "क्या आप हर दिन अमीर हो रहे हैं या गरीब?",
    "hero.premiumSub": "30 सेकंड में जानें। आपका वित्तीय भविष्य, कल्पना में।",
    "hero.wealthCardTitle": "भविष्य धन सिम्युलेटर",
    "hero.monthlySavings": "मासिक बचत",
    "hero.premiumCta": "स्वतंत्रता का मेरा मार्ग दिखाएं",
    "cat.all": "सभी उपकरण",
    "cat.debt": "ऋण-मुक्त मार्ग",
    "cat.invest": "निवेश करें और बढ़ाएं",
    "cat.home": "घर खरीदें",
    "cat.kids": "बच्चों के लिए योजना",
    "cat.tax": "कर बचाएं",
    "tool.wealth.title": "धन इंजन",
    "tool.wealth.micro": "आपका SIP कितनी तेजी से बढ़ सकता है? चक्रवृद्धि का जादू देखें।",
    "tool.stock.title": "स्टॉक लैब",
    "tool.stock.micro": "क्या आपका पसंदीदा स्टॉक एक जाल है? लाइव डेटा, चार्ट और बुनियादी बातें।",
    "tool.multiAsset.title": "मल्टी-एसेट तुलना",
    "tool.multiAsset.micro": "FD बनाम सोना बनाम स्टॉक बनाम इंडेक्स — 10 साल में कौन जीतता है?",
    "tool.realEstate.title": "रियल एस्टेट प्लानर",
    "tool.realEstate.micro": "आपके सपनों के घर की वास्तविक लागत — EMI, स्टांप शुल्क और छिपे हुए शुल्क।",
    "tool.rentBuy.title": "किराया बनाम खरीदें",
    "tool.rentBuy.micro": "आपके सपनों के घर के पीछे का गणित। क्या आपको किराए पर लेना चाहिए या खरीदना चाहिए?",
    "tool.retirement.title": "सेवानिवृत्ति घड़ी",
    "tool.retirement.micro": "सेवानिवृत्त होने के लिए आपको कितने पैसे की आवश्यकता है? अपना जादुई नंबर खोजें।",
    "tool.taxSim.title": "कर सिम्युलेटर",
    "tool.taxSim.micro": "पुरानी बनाम नई व्यवस्था — कौन सा आपको अधिक बचाता है? तुरंत पता लगाएं।",
    "tool.debt.title": "ऋण-मुक्त मार्ग",
    "tool.debt.micro": "ब्याज देना बंद करें, जीना शुरू करें। अपने ऋणों को तेजी से कुचलें।",
    "tool.creditCard.title": "क्रेडिट कार्ड मास्टर",
    "tool.creditCard.micro": "ऋण जाल सिम्युलेटर, CIBIL भविष्यवक्ता और वास्तविक इनाम कैलकुलेटर।",
    "tool.childFuture.title": "बच्चे का भविष्य",
    "tool.childFuture.micro": "आपके बच्चे की शिक्षा के सपनों के लिए मासिक बचत की योजना बनाएं।",
    "tool.canibuyit.title": "क्या मैं इसे खरीदूँ?",
    "tool.canibuyit.micro": "क्या आप इसे वास्तव में वहन कर सकते हैं? सभी छिपी हुई लागतों के साथ नकद बनाम EMI।",
    "tool.emergency.title": "आपातकालीन निधि",
    "tool.emergency.micro": "आपको वास्तव में कितनी सुरक्षा जाल की आवश्यकता है? अभी पता करें।",
    "tool.inflation.title": "मुद्रास्फीति मशीन",
    "tool.inflation.micro": "₹100 ₹50 जैसा क्यों लगता है। आपके धन का मौन चोर।",
    "tool.compare.title": "उत्पाद तुलना",
    "tool.compare.micro": "क्रेडिट कार्ड, बचत खाते और बीमा की तुलना करें।",
    "contact.title": "मदद चाहिए? हम यहां हैं।",
    "contact.desc": "प्रश्न, प्रतिक्रिया, या बस नमस्ते कहना चाहते हैं? कभी भी संपर्क करें।",
    "nav.stockLab": "स्टॉक लैब",
    "nav.goalTracker": "लक्ष्य",
    "nav.contact": "संपर्क",
    "nav.taxPlanner": "कर योजना",
    "nav.propertyPlanner": "संपत्ति",
    "footer.terms": "उपयोग की शर्तें",
  },
  kn: {
    "home.toolkitTitle": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಹಣಕಾಸು ಟೂಲ್‌ಕಿಟ್",
    "home.toolkitSub": "ಆಧುನಿಕ ಭಾರತೀಯ ಗಳಿಕೆದಾರರಿಗೆ 12 ಶಕ್ತಿಶಾಲಿ ಟೂಲ್‌ಗಳು — ನಿಮ್ಮ ಮೊದಲ SIP ನಿಂದ ನಿವೃತ್ತಿ ಕಾರ್ಪಸ್ ವರೆಗೆ.",
    "home.catInvest": "💰 ಹೂಡಿಕೆ ಮತ್ತು ಬೆಳವಣಿಗೆ",
    "home.catPlan": "🏠 ಯೋಜನೆ ಮತ್ತು ರಕ್ಷಣೆ",
    "home.catTax": "📋 ತೆರಿಗೆ ಮತ್ತು ಸಾಲ",
    "home.catLife": "🎯 ಜೀವನ ಹಂತಗಳು",
    "home.toolWealth": "ವೆಲ್ತ್ ಎಂಜಿನ್",
    "home.toolWealthDesc": "SIP, ಏಕಮುಷ್ಟಿ, ಸ್ಟೆಪ್-ಅಪ್ ಮತ್ತು ವಿಳಂಬದ ವೆಚ್ಚ — ಭಾರತೀಯ ಹೂಡಿಕೆದಾರರಿಗೆ ಅತ್ಯಂತ ಶಕ್ತಿಶಾಲಿ ಕಂಪೌಂಡಿಂಗ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್.",
    "home.toolStock": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್ ಲ್ಯಾಬ್",
    "home.toolStockDesc": "ಲೈವ್ ಮಾರ್ಕೆಟ್ ಡೇಟಾ, ಕಂಪನಿ ಫಂಡಮೆಂಟಲ್ಸ್ ಮತ್ತು TradingView ಚಾರ್ಟ್‌ಗಳು.",
    "home.toolMultiAsset": "ಮಲ್ಟಿ-ಆಸ್ಟ್ ತುಲನೆ",
    "home.toolMultiAssetDesc": "FD, ಚಿನ್ನ, ಇಂಡೆಕ್ಸ್ ಮತ್ತು ಈಕ್ವಿಟಿಯಲ್ಲಿ SIP ಬೆಳವಣಿಗೆಯನ್ನು ಹೋಲಿಸಿ — ಒಂದೇ ಚಾರ್ಟ್‌ನಲ್ಲಿ 'ವೆಲ್ತ್ ಗ್ಯಾಪ್' ನೋಡಿ.",
    "home.toolRealEstate": "ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಪ್ಲಾನರ್",
    "home.toolRealEstateDesc": "ಬಜೆಟ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್, EMI ಸಿಮ್ಯುಲೇಟರ್ ಮತ್ತು ಸ್ಟ್ಯಾಂಪ್ ಡ್ಯೂಟಿ ಅಂದಾಜು — ನಿಮ್ಮ ಕನಸಿನ ಮನೆಯ ನಿಜವಾದ ವೆಚ್ಚ ತಿಳಿಯಿರಿ.",
    "home.toolRentBuy": "ಬಾಡಿಗೆ vs ಖರೀದಿ ವಿಶ್ಲೇಷಕ",
    "home.toolRentBuyDesc": "20 ವರ್ಷಗಳ ಸಂಪತ್ತು ಹೋಲಿಕೆ: ಒಟ್ಟು ಮಾಲೀಕತ್ವ ವೆಚ್ಚ vs ಬಾಡಿಗೆ + ಡೌನ್ ಪೇಮೆಂಟ್ ಹೂಡಿಕೆ.",
    "home.toolRetirement": "ನಿವೃತ್ತಿ ಗಡಿಯಾರ",
    "home.toolRetirementDesc": "ಆರಾಮದಾಯಕವಾಗಿ ನಿವೃತ್ತಿ ಪಡೆಯಲು ಎಷ್ಟು ಬೇಕು? ನಿಮ್ಮ ಕಾರ್ಪಸ್ ಮತ್ತು ಮಾಸಿಕ SIP ಲೆಕ್ಕ ಹಾಕಿ.",
    "home.toolTaxSim": "ತೆರಿಗೆ ಸಿಮ್ಯುಲೇಟರ್",
    "home.toolTaxSimDesc": "ಹಳೆಯ vs ಹೊಸ ರಿಜೀಮ್ ಹೋಲಿಕೆ — HRA, 80C, NPS ಮತ್ತು ಫ್ರೀಲಾನ್ಸರ್ 44ADA ಬೆಂಬಲ.",
    "home.toolDebt": "ಸಾಲದಿಂದ ಮುಕ್ತಿ",
    "home.toolDebtDesc": "ಸ್ನೋಬಾಲ್ vs ಅವಲಾಂಚ್ ತಂತ್ರಗಳು — ನೀವು ಸಾಲಗಳ ಮೇಲೆ ಎಷ್ಟು ಹೆಚ್ಚು ಬಡ್ಡಿ ಕೊಡುತ್ತಿದ್ದೀರಿ ಎಂದು ತಿಳಿಯಿರಿ.",
    "home.toolCreditCard": "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಮಾಸ್ಟರ್",
    "home.toolCreditCardDesc": "ಸಾಲ ಬಲೆ ಸಿಮ್ಯುಲೇಟರ್, CIBIL ಪ್ರೆಡಿಕ್ಟರ್ ಮತ್ತು ಟ್ರೂ ರಿವಾರ್ಡ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್.",
    "home.toolInflation": "ಹಣದುಬ್ಬರ ರಿಯಾಲಿಟಿ ಮಷೀನ್",
    "home.toolInflationDesc": "ಇಂದಿನ ₹1,000 10 ವರ್ಷಗಳಲ್ಲಿ ₹558 ಆಗುವುದನ್ನು ನೋಡಿ — ಹಾಲಿನ ಪ್ಯಾಕೆಟ್ ಗಣಿತದಿಂದ ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ.",
    "home.toolChildFuture": "ಮಗುವಿನ ಭವಿಷ್ಯ ಪ್ಲಾನರ್",
    "home.toolChildFutureDesc": "ಡಾಕ್ಟರ್, IIT, ವಿದೇಶಿ ಅಧ್ಯಯನ ಮತ್ತು ಇನ್ನಷ್ಟಕ್ಕೆ ಮಾಸಿಕ SIP ರಿವರ್ಸ್-ಎಂಜಿನಿಯರ್ ಮಾಡಿ.",
    "home.toolEMI": "EMI ಮೆಂಟರ್",
    "home.toolEMIDesc": "ಆ ಖರೀದಿ ನಿಜವಾಗಿಯೂ ನಿಮಗೆ ಸಾಧ್ಯವೇ? ಕ್ಯಾಶ್ vs EMI ಅಡಗಿರುವ ವೆಚ್ಚಗಳ ತುಲನೆ.",
    "hero.journeyTitle": "ಇಂದೇ ನಿಮ್ಮ ಹೂಡಿಕೆ ಪ್ರಯಾಣ ಪ್ರಾರಂಭಿಸಿ",
    "hero.journeyDesc": "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ — ನಿಮ್ಮ ಹಣಕಾಸಿನ ಬಗ್ಗೆ ಕೆಲವು ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ, ವೈಯಕ್ತಿಕ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಪಡೆಯಿರಿ.",
    "hero.journeyCta": "ಪ್ರಾರಂಭಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ →",
    "home.viewAllTools": "ಎಲ್ಲಾ ಟೂಲ್‌ಗಳನ್ನು ನೋಡಿ",
    "home.whyTitle": "'ಸಾಥಿ' ಎಂದರೆ ಕೇವಲ ಟೂಲ್ ಅಲ್ಲ",
    "home.whySub": "RupeeVikas ಕೇವಲ ಕ್ಯಾಲ್ಕುಲೇಟರ್ ಅಲ್ಲ — ಇದು ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಮಾತನಾಡುವ ಮತ್ತು ಭಾರತೀಯ ಹಣವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುವ ನಿಮ್ಮ ಹಣಕಾಸು ಸಂಗಾತಿ.",
    "home.whyFreeTitle": "100% ಉಚಿತ ಮತ್ತು ಖಾಸಗಿ",
    "home.whyFreeDesc": "ಟೂಲ್‌ಗಳಿಗೆ ಸೈನ್-ಅಪ್ ಅಗತ್ಯವಿಲ್ಲ. ನಿಮ್ಮ ಡೇಟಾ ನಿಮ್ಮ ಸಾಧನದಲ್ಲಿ ಉಳಿಯುತ್ತದೆ.",
    "home.whyLangTitle": "13 ಭಾರತೀಯ ಭಾಷೆಗಳು",
    "home.whyLangDesc": "ಹಿಂದಿಯಿಂದ ಕನ್ನಡ, ತಮಿಳಿನಿಂದ ಅಸ್ಸಾಮಿ — ಹಣಕಾಸು ಸಾಕ್ಷರತೆಗೆ ಭಾಷೆಯ ಅಡೆತಡೆ ಇರಬಾರದು.",
    "home.whyIndiaTitle": "ಭಾರತಕ್ಕಾಗಿ ನಿರ್ಮಿಸಲಾಗಿದೆ",
    "home.whyIndiaDesc": "ಭಾರತೀಯ ತೆರಿಗೆ ರಿಜೀಮ್‌ಗಳು, SEBI ನಿಯಮಗಳು, RBI ದರಗಳು, ಮತ್ತು UPI-ಯುಗ ಸಾಲ ನಿರ್ವಹಣೆ.",
    "home.whySathiTitle": "ಸಾಥಿ ಬುದ್ಧಿಮತ್ತೆ",
    "home.whySathiDesc": "ಪ್ರತಿ ಟೂಲ್ ಜೊತೆ ಸಂದರ್ಭ-ಆಧಾರಿತ ಸಲಹೆಗಳು — ಹಣಕಾಸು ತಿಳಿದ ಸ್ನೇಹಿತ ನಿಮ್ಮ ಜೊತೆಗಿರುವಂತೆ.",
    "home.statTools": "ಹಣಕಾಸು ಟೂಲ್‌ಗಳು",
    "home.statLangs": "ಭಾರತೀಯ ಭಾಷೆಗಳು",
    "home.statFree": "ಶಾಶ್ವತವಾಗಿ ಉಚಿತ",
    "home.statPrivacy": "ಗೌಪ್ಯತೆ ಮೊದಲು",
    "home.footerDisclaimer2": "ಒದಗಿಸಿದ ಡೇಟಾ ಶೈಕ್ಷಣಿಕ ಬಳಕೆಗೆ ಮಾತ್ರ. ಎಲ್ಲಾ ಬಡ್ಡಿ ದರಗಳು ಮತ್ತು ತೆರಿಗೆ ಕಾನೂನುಗಳು ಮಾರ್ಚ್ 2026 ರ ಅನ್ವಯ ನವೀಕರಿಸಲಾಗಿದೆ.",
    "home.footerIndian": "🇮🇳 100% ಭಾರತೀಯ-ಒಡೆತನ — ಭಾರತೀಯ ತೆರಿಗೆ ರಿಜೀಮ್‌ಗಳು, ಭಾರತೀಯ ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಕಾನೂನುಗಳು, ಮತ್ತು UPI-ಆಧಾರಿತ ಸಾಲ ನಿರ್ವಹಣೆ.",
    "nav.stockResearch": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್",
    "explore.title": "ಎಲ್ಲಾ ಟೂಲ್‌ಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    "explore.subtitle": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಹಣಕಾಸು ಟೂಲ್‌ಕಿಟ್ — ಕ್ಯಾಲ್ಕುಲೇಟರ್‌ಗಳು, ಪ್ಲಾನರ್‌ಗಳು ಮತ್ತು ಹೋಲಿಕೆ ಎಂಜಿನ್‌ಗಳು",
    "explore.openTool": "ಟೂಲ್ ತೆರೆಯಿರಿ",
    "explore.toolCalc": "ಹೂಡಿಕೆ ಕ್ಯಾಲ್ಕುಲೇಟರ್‌ಗಳು",
    "explore.toolCalcDesc": "SIP, ಏಕಮುಷ್ಟಿ, ಮತ್ತು ಇನ್ನಷ್ಟು ಹೂಡಿಕೆ ಕ್ಯಾಲ್ಕುಲೇಟರ್‌ಗಳು",
    "explore.toolDebt": "ಸಾಲದಿಂದ ಮುಕ್ತಿ",
    "explore.toolDebtDesc": "ಸಾಲವನ್ನು ವೇಗವಾಗಿ ತೀರಿಸಲು ಸ್ನೋಬಾಲ್ vs ಅವಲಾಂಚ್ ತಂತ್ರಗಳು",
    "explore.toolTaxSim": "ತೆರಿಗೆ ಸಿಮ್ಯುಲೇಟರ್",
    "explore.toolTaxSimDesc": "ಹಳೆಯ vs ಹೊಸ ರಿಜೀಮ್‌ನಲ್ಲಿ ನಿಮ್ಮ ತೆರಿಗೆ ಹೊಣೆಗಾರಿಕೆ ಸಿಮ್ಯುಲೇಟ್ ಮಾಡಿ",
    "explore.toolRealEstate": "ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಪ್ಲಾನರ್",
    "explore.toolRealEstateDesc": "ಬಜೆಟ್, ROI ಸಿಮ್ಯುಲೇಟರ್, ಮತ್ತು ಸಾಮರ್ಥ್ಯ ಪರಿಶೀಲನೆ",
    "explore.toolRentBuy": "ಬಾಡಿಗೆ vs ಖರೀದಿ ವಿಶ್ಲೇಷಕ",
    "explore.toolRentBuyDesc": "15 ವರ್ಷಗಳ ಸಂಪತ್ತು ಪ್ರಕ್ಷೇಪಣೆಯೊಂದಿಗೆ ಬಾಡಿಗೆ vs ಖರೀದಿ ಹೋಲಿಕೆ",
    "explore.toolRetirement": "ನಿವೃತ್ತಿ ಗಡಿಯಾರ",
    "explore.toolRetirementDesc": "ನಿವೃತ್ತಿ ಕಾರ್ಪಸ್ ಮತ್ತು ಮಾಸಿಕ SIP ಯೋಜಿಸಿ",
    "explore.toolCompare": "ಉತ್ಪನ್ನ ಹೋಲಿಕೆ",
    "explore.toolCompareDesc": "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್‌ಗಳು, ಉಳಿತಾಯ ಖಾತೆಗಳು ಮತ್ತು ಆರೋಗ್ಯ ವಿಮೆ ಹೋಲಿಸಿ",
    "explore.toolEMI": "ಸಾಮರ್ಥ್ಯ ಮತ್ತು EMI ಮೆಂಟರ್",
    "explore.toolEMIDesc": "ನಿಜವಾಗಿಯೂ ನಿಮಗೆ ಸಾಧ್ಯವೇ? ಕ್ಯಾಶ್ vs EMI ಅಡಗಿರುವ ವೆಚ್ಚಗಳ ತುಲನೆ",
    "explore.toolInflation": "ಹಣದುಬ್ಬರ ರಿಯಾಲಿಟಿ ಮಷೀನ್",
    "explore.toolInflationDesc": "ಹಣದುಬ್ಬರ ಹೇಗೆ ಮೌನವಾಗಿ ನಿಮ್ಮ ಉಳಿತಾಯ ತಿನ್ನುತ್ತದೆ ಎಂದು ನೋಡಿ",
    "explore.toolEmergency": "ಎಮರ್ಜೆನ್ಸಿ ಫಂಡ್ ಟೆಸ್ಟರ್",
    "explore.toolEmergencyDesc": "ನಿಮ್ಮ ಆದರ್ಶ ಸೇಫ್ಟಿ ನೆಟ್ ಲೆಕ್ಕ ಹಾಕಲು ಕ್ವಿಜ್-ಆಧಾರಿತ ಸ್ಟ್ರೆಸ್ ಟೆಸ್ಟ್",
    "explore.toolChildFuture": "ಮಗುವಿನ ಭವಿಷ್ಯ ಪ್ಲಾನರ್",
    "explore.toolChildFutureDesc": "ಮಗುವಿನ ಶಿಕ್ಷಣ ಕನಸಿಗೆ SIP ರಿವರ್ಸ್-ಎಂಜಿನಿಯರ್ ಮಾಡಿ",
    "explore.toolCreditCard": "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಮಾಸ್ಟರ್",
    "explore.toolCreditCardDesc": "ಸಾಲ ಬಲೆ ಸಿಮ್ಯುಲೇಟರ್, CIBIL ಪ್ರೆಡಿಕ್ಟರ್ ಮತ್ತು ಟ್ರೂ ರಿವಾರ್ಡ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್",
    "explore.toolMultiAsset": "ಮಲ್ಟಿ-ಅಸೆಟ್ ಹೋಲಿಕೆ",
    "explore.toolMultiAssetDesc": "FD, ಚಿನ್ನ, ರಿಯಲ್ ಎಸ್ಟೇಟ್, ಇಂಡೆಕ್ಸ್ ಫಂಡ್ ಮತ್ತು ಷೇರು ರಿಟರ್ನ್ ಹೋಲಿಸಿ",
    "explore.toolStock": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್ ಲ್ಯಾಬ್",
    "explore.toolStockDesc": "ಲೈವ್ ಮಾರ್ಕೆಟ್ ಡೇಟಾ, ಕಂಪನಿ ಫಂಡಮೆಂಟಲ್ಸ್ ಮತ್ತು TradingView ಚಾರ್ಟ್‌ಗಳು",
    "comp.bestFor": "ಇದಕ್ಕೆ ಉತ್ತಮ:",
    "comp.frequentFlyers": "ಆಗಾಗ ಪ್ರಯಾಣಿಸುವವರು",
    "comp.onlineShoppers": "ಆನ್‌ಲೈನ್ ಶಾಪರ್‌ಗಳು",
    // Premium redesign keys
    "hero.premiumHeadline": "ನೀವು ಪ್ರತಿದಿನ ಶ್ರೀಮಂತರಾಗುತ್ತಿದ್ದೀರಾ ಅಥವಾ ಬಡವರಾಗುತ್ತಿದ್ದೀರಾ?",
    "hero.premiumSub": "30 ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ ತಿಳಿದುಕೊಳ್ಳಿ. ನಿಮ್ಮ ಆರ್ಥಿಕ ಭವಿಷ್ಯ, ದೃಶ್ಯೀಕರಿಸಲಾಗಿದೆ.",
    "hero.wealthCardTitle": "ಭವಿಷ್ಯ ಸಂಪತ್ತು ಸಿಮ್ಯುಲೇಟರ್",
    "hero.monthlySavings": "ಮಾಸಿಕ ಉಳಿತಾಯ",
    "hero.premiumCta": "ಸ್ವಾತಂತ್ರ್ಯದ ನನ್ನ ಮಾರ್ಗವನ್ನು ತೋರಿಸಿ",
    "cat.all": "ಎಲ್ಲಾ ಉಪಕರಣಗಳು",
    "cat.debt": "ಸಾಲ-ಮುಕ್ತ ಮಾರ್ಗ",
    "cat.invest": "ಹೂಡಿಕೆ ಮಾಡಿ ಮತ್ತು ಬೆಳೆಯಿರಿ",
    "cat.home": "ಮನೆ ಖರೀದಿಸಿ",
    "cat.kids": "ಮಕ್ಕಳಿಗಾಗಿ ಯೋಜನೆ",
    "cat.tax": "ತೆರಿಗೆ ಉಳಿಸಿ",
    "tool.wealth.title": "ಸಂಪತ್ತು ಎಂಜಿನ್",
    "tool.wealth.micro": "ನಿಮ್ಮ SIP ಎಷ್ಟು ವೇಗವಾಗಿ ಬೆಳೆಯಬಹುದು? ಸಂಯುಕ್ತ ಶಕ್ತಿಯ ಅದ್ಭುತವನ್ನು ನೋಡಿ.",
    "tool.stock.title": "ಸ್ಟಾಕ್ ಲ್ಯಾಬ್",
    "tool.stock.micro": "ನಿಮ್ಮ ನೆಚ್ಚಿನ ಸ್ಟಾಕ್ ಒಂದು ಅಪಾಯವೇ? ಲೈವ್ ಡೇಟಾ, ಚಾರ್ಟ್‌ಗಳು ಮತ್ತು ಮೂಲಭೂತ ಅಂಶಗಳು.",
    "tool.multiAsset.title": "ಬಹು-ಆಸ್ತಿ ಹೋಲಿಕೆ",
    "tool.multiAsset.micro": "FD vs ಚಿನ್ನ vs ಸ್ಟಾಕ್‌ಗಳು vs ಸೂಚ್ಯಂಕ — 10 ವರ್ಷಗಳಲ್ಲಿ ಯಾರು ಗೆಲ್ಲುತ್ತಾರೆ?",
    "tool.realEstate.title": "ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಯೋಜಕ",
    "tool.realEstate.micro": "ನಿಮ್ಮ ಕನಸಿನ ಮನೆಯ ನಿಜವಾದ ವೆಚ್ಚ — EMI, ಸ್ಟಾಂಪ್ ಡ್ಯೂಟಿ ಮತ್ತು ಗುಪ್ತ ಶುಲ್ಕಗಳು.",
    "tool.rentBuy.title": "ಬಾಡಿಗೆ vs ಖರೀದಿ",
    "tool.rentBuy.micro": "ನಿಮ್ಮ ಕನಸಿನ ಮನೆಯ ಹಿಂದಿನ ಗಣಿತ. ನೀವು ಬಾಡಿಗೆಗೆ ಪಡೆಯಬೇಕೇ ಅಥವಾ ಖರೀದಿಸಬೇಕೇ?",
    "tool.retirement.title": "ನಿವೃತ್ತಿ ಗಡಿಯಾರ",
    "tool.retirement.micro": "ನಿವೃತ್ತಿ ಹೊಂದಲು ನಿಮಗೆ ಎಷ್ಟು ಬೇಕು? ನಿಮ್ಮ ಮ್ಯಾಜಿಕ್ ಸಂಖ್ಯೆಯನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ.",
    "tool.taxSim.title": "ತೆರಿಗೆ ಸಿಮ್ಯುಲೇಟರ್",
    "tool.taxSim.micro": "ಹಳೆಯ vs ಹೊಸ ವ್ಯವಸ್ಥೆ — ಯಾವುದು ನಿಮಗೆ ಹೆಚ್ಚು ಉಳಿಸುತ್ತದೆ? ತಕ್ಷಣವೇ ತಿಳಿದುಕೊಳ್ಳಿ.",
    "tool.debt.title": "ಸಾಲ-ಮುಕ್ತ ಮಾರ್ಗ",
    "tool.debt.micro": "ಬಡ್ಡಿ ಪಾವತಿಸುವುದನ್ನು ನಿಲ್ಲಿಸಿ, ಬದುಕಲು ಪ್ರಾರಂಭಿಸಿ. ನಿಮ್ಮ ಸಾಲಗಳನ್ನು ವೇಗವಾಗಿ ಮುರಿಯಿರಿ.",
    "tool.creditCard.title": "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಮಾಸ್ಟರ್",
    "tool.creditCard.micro": "ಸಾಲದ ಸುಳಿಯ ಸಿಮ್ಯುಲೇಟರ್, CIBIL ಭವಿಷ್ಯವಾಣಿ ಮತ್ತು ನಿಜವಾದ ಪ್ರತಿಫಲ ಕ್ಯಾಲ್ಕುಲೇಟರ್.",
    "tool.childFuture.title": "ಮಗುವಿನ ಭವಿಷ್ಯ",
    "tool.childFuture.micro": "ನಿಮ್ಮ ಮಗುವಿನ ಶಿಕ್ಷಣದ ಕನಸುಗಳಿಗಾಗಿ ಮಾಸಿಕ ಉಳಿತಾಯವನ್ನು ಯೋಜಿಸಿ.",
    "tool.canibuyit.title": "ನಾನು ಇದನ್ನು ಖರೀದಿಸಬಹುದೇ?",
    "tool.canibuyit.micro": "ನೀವು ನಿಜವಾಗಿಯೂ ಅದನ್ನು ಭರಿಸಬಹುದೇ? ಎಲ್ಲಾ ಗುಪ್ತ ವೆಚ್ಚಗಳೊಂದಿಗೆ ನಗದು vs EMI.",
    "tool.emergency.title": "ತುರ್ತು ನಿಧಿ",
    "tool.emergency.micro": "ನಿಮಗೆ ನಿಜವಾಗಿಯೂ ಎಷ್ಟು ಸುರಕ್ಷತಾ ಜಾಲ ಬೇಕು? ಈಗ ತಿಳಿದುಕೊಳ್ಳಿ.",
    "tool.inflation.title": "ಹಣದುಬ್ಬರ ಯಂತ್ರ",
    "tool.inflation.micro": "₹100 ₹50 ನಂತೆ ಏಕೆ ಅನಿಸುತ್ತದೆ. ನಿಮ್ಮ ಸಂಪತ್ತಿನ ಮೌನ ಕಳ್ಳ.",
    "tool.compare.title": "ಉತ್ಪನ್ನ ಹೋಲಿಕೆ",
    "tool.compare.micro": "ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್‌ಗಳು, ಉಳಿತಾಯ ಖಾತೆಗಳು ಮತ್ತು ವಿಮೆಯನ್ನು ಅಕ್ಕಪಕ್ಕ ಹೋಲಿಸಿ.",
    "contact.title": "ಸಹಾಯ ಬೇಕೇ? ನಾವು ಇಲ್ಲಿದ್ದೇವೆ.",
    "contact.desc": "ಪ್ರಶ್ನೆಗಳು, ಪ್ರತಿಕ್ರಿಯೆ, ಅಥವಾ ಕೇವಲ ಹಾಯ್ ಹೇಳಬೇಕೇ? ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ.",
    "nav.stockLab": "ಸ್ಟಾಕ್ ಲ್ಯಾಬ್",
    "nav.goalTracker": "ಗುರಿಗಳು",
    "nav.contact": "ಸಂಪರ್ಕಿಸಿ",
    "nav.taxPlanner": "ತೆರಿಗೆ ಯೋಜನೆ",
    "nav.propertyPlanner": "ಆಸ್ತಿ",
    "footer.terms": "ಬಳಕೆಯ ನಿಯಮಗಳು",
  },
  bn: {
    "home.toolkitTitle": "আপনার সম্পূর্ণ আর্থিক টুলকিট",
    "home.toolkitSub": "আধুনিক ভারতীয় উপার্জনকারীদের জন্য ১২টি শক্তিশালী টুল — আপনার প্রথম SIP থেকে অবসর কর্পাস পর্যন্ত।",
    "home.catInvest": "💰 বিনিয়োগ ও বৃদ্ধি",
    "home.catPlan": "🏠 পরিকল্পনা ও সুরক্ষা",
    "home.catTax": "📋 কর ও ঋণ",
    "home.catLife": "🎯 জীবনের পর্যায়",
    "home.toolWealth": "ওয়েলথ ইঞ্জিন",
    "home.toolWealthDesc": "SIP, একমুঠো, স্টেপ-আপ ও বিলম্বের খরচ — ভারতীয় বিনিয়োগকারীদের জন্য সবচেয়ে শক্তিশালী কম্পাউন্ডিং ক্যালকুলেটর।",
    "home.toolStock": "স্টক রিসার্চ ল্যাব",
    "home.toolStockDesc": "লাইভ মার্কেট ডেটা, কোম্পানি ফান্ডামেন্টালস ও TradingView চার্ট।",
    "home.toolMultiAsset": "মাল্টি-অ্যাসেট তুলনা",
    "home.toolMultiAssetDesc": "FD, সোনা, ইনডেক্স ও ইক্যুইটিতে SIP বৃদ্ধি তুলনা করুন।",
    "home.toolRealEstate": "রিয়েল এস্টেট প্ল্যানার",
    "home.toolRealEstateDesc": "বাজেট ক্যালকুলেটর, EMI সিমুলেটর ও স্ট্যাম্প ডিউটি অনুমান।",
    "home.toolRentBuy": "ভাড়া vs কেনা বিশ্লেষক",
    "home.toolRentBuyDesc": "২০ বছরের সম্পদ তুলনা: মোট মালিকানা খরচ vs ভাড়া + ডাউন পেমেন্ট বিনিয়োগ।",
    "home.toolRetirement": "অবসর ঘড়ি",
    "home.toolRetirementDesc": "আরামদায়ক অবসরের জন্য কত লাগবে? আপনার কর্পাস ও মাসিক SIP গণনা করুন।",
    "home.toolTaxSim": "ট্যাক্স সিমুলেটর",
    "home.toolTaxSimDesc": "পুরানো vs নতুন রেজিম তুলনা — HRA, 80C, NPS ও ফ্রিল্যান্সার 44ADA সাপোর্ট।",
    "home.toolDebt": "ঋণ-মুক্তি পথ",
    "home.toolDebtDesc": "স্নোবল vs অ্যাভালাঞ্চ কৌশল — আপনি লোনে কত বেশি সুদ দিচ্ছেন তা জানুন।",
    "home.toolCreditCard": "ক্রেডিট কার্ড মাস্টার",
    "home.toolCreditCardDesc": "ঋণ ফাঁদ সিমুলেটর, CIBIL প্রেডিক্টর ও ট্রু রিওয়ার্ড ক্যালকুলেটর।",
    "home.toolInflation": "মুদ্রাস্ফীতি রিয়ালিটি মেশিন",
    "home.toolInflationDesc": "দেখুন আজকের ₹১,০০০ কীভাবে ১০ বছরে ₹৫৫৮ হয়ে যায়।",
    "home.toolChildFuture": "সন্তানের ভবিষ্যৎ প্ল্যানার",
    "home.toolChildFutureDesc": "ডাক্তার, IIT, বিদেশ পড়াশোনার জন্য মাসিক SIP রিভার্স-ইঞ্জিনিয়ার করুন।",
    "home.toolEMI": "EMI মেন্টর",
    "home.toolEMIDesc": "সেই কেনাকাটা কি সত্যিই সম্ভব? ক্যাশ vs EMI লুকানো খরচ তুলনা।",
    "hero.journeyTitle": "আজই আপনার বিনিয়োগ যাত্রা শুরু করুন",
    "hero.journeyDesc": "এখানে ক্লিক করুন — আপনার অর্থের বিষয়ে কিছু প্রশ্নের উত্তর দিন, ব্যক্তিগত ড্যাশবোর্ড পান।",
    "hero.journeyCta": "শুরু করতে এখানে ক্লিক করুন →",
    "home.viewAllTools": "সব টুল দেখুন",
    "home.whyTitle": "'সাথী' মানে শুধু একটি টুল নয়",
    "home.whySub": "RupeeVikas শুধু ক্যালকুলেটর নয় — এটি আপনার ভাষায় কথা বলা আর্থিক সঙ্গী।",
    "home.whyFreeTitle": "১০০% বিনামূল্যে ও ব্যক্তিগত",
    "home.whyFreeDesc": "টুলের জন্য সাইন-আপ দরকার নেই। আপনার ডেটা আপনার ডিভাইসে থাকে।",
    "home.whyLangTitle": "১৩টি ভারতীয় ভাষা",
    "home.whyLangDesc": "হিন্দি থেকে কন্নড, তামিল থেকে অসমীয়া — আর্থিক সাক্ষরতায় ভাষার বাধা থাকা উচিত নয়।",
    "home.whyIndiaTitle": "ভারতের জন্য তৈরি",
    "home.whyIndiaDesc": "ভারতীয় ট্যাক্স রেজিম, SEBI নিয়ম, RBI রেট, এবং UPI-যুগ ঋণ ব্যবস্থাপনা।",
    "home.whySathiTitle": "সাথী বুদ্ধিমত্তা",
    "home.whySathiDesc": "প্রতিটি টুলে প্রসঙ্গ-ভিত্তিক পরামর্শ — যেন একজন আর্থিক-বিচক্ষণ বন্ধু পাশে।",
    "home.statTools": "আর্থিক টুল",
    "home.statLangs": "ভারতীয় ভাষা",
    "home.statFree": "চিরকাল বিনামূল্যে",
    "home.statPrivacy": "গোপনীয়তা প্রথম",
    "home.footerDisclaimer2": "প্রদত্ত ডেটা শুধুমাত্র শিক্ষামূলক ব্যবহারের জন্য। সমস্ত সুদের হার এবং কর আইন মার্চ ২০২৬ পর্যন্ত আপডেট।",
    "home.footerIndian": "🇮🇳 ১০০% ভারতীয়-মালিকানাধীন — ভারতীয় কর ব্যবস্থা, রিয়েল এস্টেট আইন এবং UPI-ভিত্তিক ঋণ ব্যবস্থাপনায় কেন্দ্রীভূত।",
    "nav.stockResearch": "স্টক রিসার্চ",
    "explore.title": "সব টুল এক্সপ্লোর করুন",
    "explore.subtitle": "আপনার সম্পূর্ণ আর্থিক টুলকিট — ক্যালকুলেটর, প্ল্যানার ও তুলনা ইঞ্জিন",
    "explore.openTool": "টুল খুলুন",
    "explore.toolCalc": "বিনিয়োগ ক্যালকুলেটর",
    "explore.toolCalcDesc": "SIP, একমুঠো, এবং আরো বিনিয়োগ ক্যালকুলেটর",
    "explore.toolDebt": "ঋণ-মুক্তি পথ",
    "explore.toolDebtDesc": "ঋণ দ্রুত শেষ করতে স্নোবল vs অ্যাভালাঞ্চ কৌশল",
    "explore.toolTaxSim": "ট্যাক্স সিমুলেটর",
    "explore.toolTaxSimDesc": "পুরানো vs নতুন রেজিমে আপনার ট্যাক্স দায় সিমুলেট করুন",
    "explore.toolRealEstate": "রিয়েল এস্টেট প্ল্যানার",
    "explore.toolRealEstateDesc": "বাজেট, ROI সিমুলেটর, এবং সামর্থ্য পরীক্ষা",
    "explore.toolRentBuy": "ভাড়া vs কেনা বিশ্লেষক",
    "explore.toolRentBuyDesc": "১৫ বছরের সম্পদ প্রক্ষেপণ সহ ভাড়া vs কেনা তুলনা",
    "explore.toolRetirement": "অবসর ঘড়ি",
    "explore.toolRetirementDesc": "অবসর কর্পাস এবং মাসিক SIP পরিকল্পনা করুন",
    "explore.toolCompare": "পণ্য তুলনা",
    "explore.toolCompareDesc": "ক্রেডিট কার্ড, সঞ্চয় অ্যাকাউন্ট ও স্বাস্থ্য বীমা তুলনা",
    "explore.toolEMI": "সামর্থ্য ও EMI মেন্টর",
    "explore.toolEMIDesc": "সত্যিই সম্ভব? ক্যাশ vs EMI লুকানো খরচ তুলনা",
    "explore.toolInflation": "মুদ্রাস্ফীতি রিয়ালিটি মেশিন",
    "explore.toolInflationDesc": "মুদ্রাস্ফীতি কীভাবে নীরবে আপনার সঞ্চয় খায় দেখুন",
    "explore.toolEmergency": "ইমার্জেন্সি ফান্ড টেস্টার",
    "explore.toolEmergencyDesc": "আপনার আদর্শ সেফটি নেট গণনা করতে কুইজ-ভিত্তিক স্ট্রেস টেস্ট",
    "explore.toolChildFuture": "সন্তানের ভবিষ্যৎ প্ল্যানার",
    "explore.toolChildFutureDesc": "সন্তানের শিক্ষার স্বপ্নের জন্য SIP রিভার্স-ইঞ্জিনিয়ার করুন",
    "explore.toolCreditCard": "ক্রেডিট কার্ড মাস্টার",
    "explore.toolCreditCardDesc": "ঋণ ফাঁদ সিমুলেটর, CIBIL প্রেডিক্টর ও ট্রু রিওয়ার্ড ক্যালকুলেটর",
    "explore.toolMultiAsset": "মাল্টি-অ্যাসেট তুলনা",
    "explore.toolMultiAssetDesc": "FD, সোনা, রিয়েল এস্টেট, ইনডেক্স ফান্ড ও স্টক রিটার্ন পাশাপাশি তুলনা করুন",
    "explore.toolStock": "স্টক রিসার্চ ল্যাব",
    "explore.toolStockDesc": "লাইভ মার্কেট ডেটা, কোম্পানি ফান্ডামেন্টালস ও TradingView চার্ট",
    "comp.bestFor": "এর জন্য সেরা:",
    "comp.frequentFlyers": "ঘন ঘন ভ্রমণকারী",
    "comp.onlineShoppers": "অনলাইন শপার",
    // Premium redesign keys
    "hero.premiumHeadline": "আপনি কি প্রতিদিন ধনী হচ্ছেন না দরিদ্র?",
    "hero.premiumSub": "30 সেকেন্ডে খুঁজে বের করুন। আপনার আর্থিক ভবিষ্যৎ, কল্পনা করা হয়েছে।",
    "hero.wealthCardTitle": "ভবিষ্যৎ সম্পদ সিমুলেটর",
    "hero.monthlySavings": "মাসিক সঞ্চয়",
    "hero.premiumCta": "স্বাধীনতার আমার পথ দেখান",
    "cat.all": "সমস্ত সরঞ্জাম",
    "cat.debt": "ঋণ-মুক্ত পথ",
    "cat.invest": "বিনিয়োগ করুন এবং বৃদ্ধি করুন",
    "cat.home": "একটি বাড়ি কেনুন",
    "cat.kids": "শিশুদের জন্য পরিকল্পনা",
    "cat.tax": "কর বাঁচান",
    "tool.wealth.title": "সম্পদ ইঞ্জিন",
    "tool.wealth.micro": "আপনার SIP কত দ্রুত বাড়তে পারে? চক্রবৃদ্ধি ম্যাজিক দেখুন।",
    "tool.stock.title": "স্টক ল্যাব",
    "tool.stock.micro": "আপনার পছন্দের স্টক কি একটি ফাঁদ? লাইভ ডেটা, চার্ট এবং মৌলিক বিষয়।",
    "tool.multiAsset.title": "মাল্টি-অ্যাসেট তুলনা",
    "tool.multiAsset.micro": "FD বনাম সোনা বনাম স্টক বনাম ইনডেক্স — 10 বছরে কে জেতে?",
    "tool.realEstate.title": "রিয়েল এস্টেট প্ল্যানার",
    "tool.realEstate.micro": "আপনার স্বপ্নের বাড়ির আসল খরচ — EMI, স্ট্যাম্প ডিউটি এবং লুকানো চার্জ।",
    "tool.rentBuy.title": "ভাড়া বনাম কিনুন",
    "tool.rentBuy.micro": "আপনার স্বপ্নের বাড়ির পিছনের গণিত। আপনার কি ভাড়া নেওয়া উচিত নাকি কেনা উচিত?",
    "tool.retirement.title": "অবসর ঘড়ি",
    "tool.retirement.micro": "অবসর নিতে আপনার কত টাকা দরকার? আপনার যাদুকর সংখ্যা খুঁজে বের করুন।",
    "tool.taxSim.title": "কর সিমুলেটর",
    "tool.taxSim.micro": "পুরানো বনাম নতুন নিয়ম — কোনটি আপনাকে বেশি বাঁচায়? তাৎক্ষণিকভাবে খুঁজে বের করুন।",
    "tool.debt.title": "ঋণ-মুক্ত পথ",
    "tool.debt.micro": "সুদ দেওয়া বন্ধ করুন, বাঁচতে শুরু করুন। আপনার ঋণ দ্রুত ভেঙে দিন।",
    "tool.creditCard.title": "ক্রেডিট কার্ড মাস্টার",
    "tool.creditCard.micro": "ঋণ ফাঁদ সিমুলেটর, CIBIL ভবিষ্যৎবাণী এবং আসল পুরস্কার ক্যালকুলেটর।",
    "tool.childFuture.title": "শিশুদের ভবিষ্যৎ",
    "tool.childFuture.micro": "আপনার শিশুর শিক্ষার স্বপ্ন পূরণের জন্য মাসিক সঞ্চয় পরিকল্পনা করুন।",
    "tool.canibuyit.title": "আমি কি এটা কিনতে পারি?",
    "tool.canibuyit.micro": "আপনি কি সত্যিই এটি বহন করতে পারেন? সমস্ত লুকানো খরচ সহ নগদ বনাম EMI।",
    "tool.emergency.title": "জরুরী তহবিল",
    "tool.emergency.micro": "আপনার আসলে কত সুরক্ষা জালের প্রয়োজন? এখনই খুঁজে বের করুন।",
    "tool.inflation.title": "মুদ্রাস্ফীতি মেশিন",
    "tool.inflation.micro": "₹100 কেন ₹50 এর মতো মনে হয়। আপনার সম্পদের নীরব চোর।",
    "tool.compare.title": "পণ্য তুলনা",
    "tool.compare.micro": "ক্রেডিট কার্ড, সেভিংস অ্যাকাউন্ট এবং বীমা পাশাপাশি তুলনা করুন।",
    "contact.title": "সাহায্য প্রয়োজন? আমরা এখানে আছি।",
    "contact.desc": "প্রশ্ন, প্রতিক্রিয়া, বা কেবল হ্যালো বলতে চান? যেকোনো সময় যোগাযোগ করুন।",
    "nav.stockLab": "স্টক ল্যাব",
    "nav.goalTracker": "লক্ষ্যসমূহ",
    "nav.contact": "যোগাযোগ",
    "footer.terms": "ব্যবহারের শর্তাবলী",
    "nav.taxPlanner": "কর পরিকল্পনা",
    "nav.propertyPlanner": "সম্পত্তি",
  },
  te: {
    "home.toolkitTitle": "మీ సంపూర్ణ ఆర్థిక టూల్‌కిట్",
    "home.toolkitSub": "ఆధునిక భారతీయ సంపాదకులకు 12 శక్తివంతమైన టూల్స్ — మీ మొదటి SIP నుండి రిటైర్‌మెంట్ కార్పస్ వరకు.",
    "home.catInvest": "💰 పెట్టుబడి & వృద్ధి",
    "home.catPlan": "🏠 ప్రణాళిక & రక్షణ",
    "home.catTax": "📋 పన్ను & అప్పు",
    "home.catLife": "🎯 జీవిత దశలు",
    "home.toolWealth": "వెల్త్ ఇంజిన్",
    "home.toolWealthDesc": "SIP, లంప్ సమ్, స్టెప్-అప్ & ఆలస్యం ఖర్చు — భారతీయ పెట్టుబడిదారులకు అత్యంత శక్తివంతమైన కంపౌండింగ్ కాలిక్యులేటర్.",
    "home.toolStock": "స్టాక్ రిసెర్చ్ ల్యాబ్",
    "home.toolStockDesc": "లైవ్ మార్కెట్ డేటా, కంపెనీ ఫండమెంటల్స్ & TradingView చార్ట్‌లు.",
    "home.toolMultiAsset": "మల్టీ-ఆస్సెట్ పోలిక",
    "home.toolMultiAssetDesc": "FD, బంగారం, ఇండెక్స్ & ఈక్విటీలో SIP వృద్ధి పోల్చండి.",
    "home.toolRealEstate": "రియల్ ఎస్టేట్ ప్లానర్",
    "home.toolRealEstateDesc": "బడ్జెట్ కాలిక్యులేటర్, EMI సిమ్యులేటర్ & స్టాంప్ డ్యూటీ అంచనా.",
    "home.toolRentBuy": "అద్దె vs కొనుగోలు విశ్లేషకుడు",
    "home.toolRentBuyDesc": "20 సంవత్సరాల సంపద పోలిక: మొత్తం యాజమాన్య ఖర్చు vs అద్దె + డౌన్ పేమెంట్ పెట్టుబడి.",
    "home.toolRetirement": "రిటైర్‌మెంట్ గడియారం",
    "home.toolRetirementDesc": "ఆరామదాయకంగా రిటైర్ కావడానికి ఎంత కావాలి? మీ కార్పస్ & మాసిక SIP లెక్కించండి.",
    "home.toolTaxSim": "పన్ను సిమ్యులేటర్",
    "home.toolTaxSimDesc": "పాత vs కొత్త రెజీమ్ పోలిక — HRA, 80C, NPS & ఫ్రీలాన్సర్ 44ADA సపోర్ట్.",
    "home.toolDebt": "అప్పు-విముక్తి",
    "home.toolDebtDesc": "స్నోబాల్ vs అవలాంచ్ వ్యూహాలు — మీరు రుణాలపై ఎంత ఎక్కువ వడ్డీ చెల్లిస్తున్నారో తెలుసుకోండి.",
    "home.toolCreditCard": "క్రెడిట్ కార్డ్ మాస్టర్",
    "home.toolCreditCardDesc": "అప్పు ఉచ్చు సిమ్యులేటర్, CIBIL ప్రెడిక్టర్ & ట్రూ రివార్డ్ కాలిక్యులేటర్.",
    "home.toolInflation": "ద్రవ్యోల్బణ రియాలిటీ మెషిన్",
    "home.toolInflationDesc": "ఈ రోజు ₹1,000 10 సంవత్సరాల్లో ₹558 ఎలా అవుతుందో చూడండి.",
    "home.toolChildFuture": "బిడ్డ భవిష్యత్ ప్లానర్",
    "home.toolChildFutureDesc": "డాక్టర్, IIT, విదేశీ చదువులకు మాసిక SIP రివర్స్-ఇంజినీర్ చేయండి.",
    "home.toolEMI": "EMI మెంటర్",
    "home.toolEMIDesc": "ఆ కొనుగోలు నిజంగా సాధ్యమా? క్యాష్ vs EMI దాచిన ఖర్చుల పోలిక.",
    "hero.journeyTitle": "ఈ రోజే మీ పెట్టుబడి ప్రయాణం ప్రారంభించండి",
    "hero.journeyDesc": "ఇక్కడ క్లిక్ చేయండి — మీ ఆర్థిక విషయాల గురించి కొన్ని ప్రశ్నలకు సమాధానం ఇవ్వండి, వ్యక్తిగత డ్యాష్‌బోర్డ్ పొందండి.",
    "hero.journeyCta": "ప్రారంభించడానికి ఇక్కడ క్లిక్ చేయండి →",
    "home.viewAllTools": "అన్ని టూల్స్ చూడండి",
    "home.whyTitle": "'సాథీ' అంటే కేవలం టూల్ కాదు",
    "home.whySub": "RupeeVikas కేవలం కాలిక్యులేటర్ కాదు — ఇది మీ భాషలో మాట్లాడే మీ ఆర్థిక సహచరుడు.",
    "home.whyFreeTitle": "100% ఉచితం & ప్రైవేట్",
    "home.whyFreeDesc": "టూల్స్ కోసం సైన్-అప్ అవసరం లేదు. మీ డేటా మీ పరికరంలోనే ఉంటుంది.",
    "home.whyLangTitle": "13 భారతీయ భాషలు",
    "home.whyLangDesc": "హిందీ నుండి కన్నడ, తమిళ నుండి అస్సామీ — ఆర్థిక అక్షరాస్యతకు భాషా అవరోధం ఉండకూడదు.",
    "home.whyIndiaTitle": "భారతదేశం కోసం నిర్మించబడింది",
    "home.whyIndiaDesc": "భారతీయ పన్ను రెజీమ్‌లు, SEBI నిబంధనలు, RBI రేట్లు, మరియు UPI-యుగ రుణ నిర్వహణ.",
    "home.whySathiTitle": "సాథీ తెలివి",
    "home.whySathiDesc": "ప్రతి టూల్‌తో సందర్భ-ఆధారిత చిట్కాలు — ఆర్థికంగా తెలివైన స్నేహితుడు పక్కన ఉన్నట్లు.",
    "home.statTools": "ఆర్థిక టూల్స్",
    "home.statLangs": "భారతీయ భాషలు",
    "home.statFree": "ఎప్పటికీ ఉచితం",
    "home.statPrivacy": "గోప్యత మొదట",
    "home.footerDisclaimer2": "అందించిన డేటా విద్యా ఉపయోగం కోసం మాత్రమే. అన్ని వడ్డీ రేట్లు మరియు పన్ను చట్టాలు మార్చి 2026 వరకు అప్‌డేట్.",
    "home.footerIndian": "🇮🇳 100% భారతీయ-యాజమాన్యం — భారతీయ పన్ను రెజీమ్‌లు, రియల్ ఎస్టేట్ చట్టాలు, మరియు UPI-ఆధారిత రుణ నిర్వహణపై దృష్టి.",
    "nav.stockResearch": "స్టాక్ రిసెర్చ్",
    "explore.title": "అన్ని టూల్స్ అన్వేషించండి",
    "explore.subtitle": "మీ సంపూర్ణ ఆర్థిక టూల్‌కిట్ — కాలిక్యులేటర్లు, ప్లానర్లు మరియు పోలిక ఇంజిన్లు",
    "explore.openTool": "టూల్ తెరవండి",
    "explore.toolCalc": "పెట్టుబడి కాలిక్యులేటర్లు",
    "explore.toolCalcDesc": "SIP, లంప్ సమ్, మరియు మరిన్ని పెట్టుబడి కాలిక్యులేటర్లు",
    "explore.toolDebt": "అప్పు-విముక్తి",
    "explore.toolDebtDesc": "అప్పును వేగంగా తీర్చడానికి స్నోబాల్ vs అవలాంచ్ వ్యూహాలు",
    "explore.toolTaxSim": "పన్ను సిమ్యులేటర్",
    "explore.toolTaxSimDesc": "పాత vs కొత్త రెజీమ్‌లో మీ పన్ను బాధ్యత సిమ్యులేట్ చేయండి",
    "explore.toolRealEstate": "రియల్ ఎస్టేట్ ప్లానర్",
    "explore.toolRealEstateDesc": "బడ్జెట్, ROI సిమ్యులేటర్, మరియు సామర్థ్య తనిఖీ",
    "explore.toolRentBuy": "అద్దె vs కొనుగోలు విశ్లేషకుడు",
    "explore.toolRentBuyDesc": "15 సంవత్సరాల సంపద ప్రక్షేపణతో అద్దె vs కొనుగోలు పోలిక",
    "explore.toolRetirement": "రిటైర్‌మెంట్ గడియారం",
    "explore.toolRetirementDesc": "రిటైర్‌మెంట్ కార్పస్ మరియు మాసిక SIP ప్లాన్ చేయండి",
    "explore.toolCompare": "ఉత్పత్తి పోలిక",
    "explore.toolCompareDesc": "క్రెడిట్ కార్డ్‌లు, సేవింగ్స్ అకౌంట్లు & ఆరోగ్య బీమా పోల్చండి",
    "explore.toolEMI": "సామర్థ్యం & EMI మెంటర్",
    "explore.toolEMIDesc": "నిజంగా సాధ్యమా? క్యాష్ vs EMI దాచిన ఖర్చుల పోలిక",
    "explore.toolInflation": "ద్రవ్యోల్బణ రియాలిటీ మెషిన్",
    "explore.toolInflationDesc": "ద్రవ్యోల్బణం నిశ్శబ్దంగా మీ పొదుపును ఎలా తింటుందో చూడండి",
    "explore.toolEmergency": "ఎమర్జెన్సీ ఫండ్ టెస్టర్",
    "explore.toolEmergencyDesc": "మీ ఆదర్శ సేఫ్టీ నెట్ లెక్కించడానికి క్విజ్-ఆధారిత స్ట్రెస్ టెస్ట్",
    "explore.toolChildFuture": "బిడ్డ భవిష్యత్ ప్లానర్",
    "explore.toolChildFutureDesc": "బిడ్డ చదువు కలకు SIP రివర్స్-ఇంజినీర్ చేయండి",
    "explore.toolCreditCard": "క్రెడిట్ కార్డ్ మాస్టర్",
    "explore.toolCreditCardDesc": "అప్పు ఉచ్చు సిమ్యులేటర్, CIBIL ప్రెడిక్టర్ & ట్రూ రివార్డ్ కాలిక్యులేటర్",
    "explore.toolMultiAsset": "మల్టీ-అసెట్ పోలిక",
    "explore.toolMultiAssetDesc": "FD, బంగారం, రియల్ ఎస్టేట్, ఇండెక్స్ ఫండ్స్ & స్టాక్ రిటర్న్‌లను పోల్చండి",
    "explore.toolStock": "స్టాక్ రిసెర్చ్ ల్యాబ్",
    "explore.toolStockDesc": "లైవ్ మార్కెట్ డేటా, కంపెనీ ఫండమెంటల్స్ & TradingView చార్ట్‌లు",
    "comp.bestFor": "దీనికి ఉత్తమం:",
    "comp.frequentFlyers": "తరచుగా ప్రయాణించేవారు",
    "comp.onlineShoppers": "ఆన్‌లైన్ షాపర్లు",
    // Premium redesign keys
    "hero.premiumHeadline": "మీరు ప్రతిరోజూ ధనవంతులు అవుతున్నారా లేదా పేదవారవుతున్నారా?",
    "hero.premiumSub": "30 సెకన్లలో తెలుసుకోండి. మీ ఆర్థిక భవిష్యత్తు, దృశ్యమానం.",
    "hero.wealthCardTitle": "భవిష్యత్ సంపద సిమ్యులేటర్",
    "hero.monthlySavings": "నెలవారీ పొదుపు",
    "hero.premiumCta": "నా స్వాతంత్ర్య మార్గాన్ని చూపించు",
    "cat.all": "అన్ని సాధనాలు",
    "cat.debt": "రుణరహిత మార్గం",
    "cat.invest": "పెట్టుబడి పెట్టండి & వృద్ధి చేసుకోండి",
    "cat.home": "ఇల్లు కొనండి",
    "cat.kids": "పిల్లల కోసం ప్రణాళిక",
    "cat.tax": "పన్ను ఆదా చేయండి",
    "tool.wealth.title": "సంపద ఇంజిన్",
    "tool.wealth.micro": "మీ SIP ఎంత వేగంగా పెరగవచ్చు? చక్రవడ్డీ మ్యాజిక్ చూడండి.",
    "tool.stock.title": "స్టాక్ ల్యాబ్",
    "tool.stock.micro": "మీకు ఇష్టమైన స్టాక్ ఒక ట్రాపా? లైవ్ డేటా, చార్ట్‌లు & ప్రాథమిక అంశాలు.",
    "tool.multiAsset.title": "మల్టీ-అసెట్ పోల్చండి",
    "tool.multiAsset.micro": "FD vs బంగారం vs స్టాక్‌లు vs సూచిక — 10 సంవత్సరాలలో ఎవరు గెలుస్తారు?",
    "tool.realEstate.title": "రియల్ ఎస్టేట్ ప్లానర్",
    "tool.realEstate.micro": "మీ కలల ఇంటి నిజమైన ఖర్చు — EMI, స్టాంప్ డ్యూటీ & దాచిన ఛార్జీలు.",
    "tool.rentBuy.title": "అద్దె vs కొనుగోలు",
    "tool.rentBuy.micro": "మీ డ్రీమ్ హోమ్ వెనుక లెక్కలు. మీరు అద్దెకు తీసుకోవాలా లేదా కొనాలా?",
    "tool.retirement.title": "పదవీ విరమణ గడియారం",
    "tool.retirement.micro": "పదవీ విరమణ చేయడానికి మీకు ఎంత అవసరం? మీ మాయా సంఖ్యను కనుగొనండి.",
    "tool.taxSim.title": "పన్ను సిమ్యులేటర్",
    "tool.taxSim.micro": "పాత vs కొత్త విధానం — ఏది మీకు ఎక్కువ ఆదా చేస్తుంది? తక్షణమే తెలుసుకోండి.",
    "tool.debt.title": "రుణరహిత మార్గం",
    "tool.debt.micro": "వడ్డీ చెల్లించడం ఆపండి, జీవించడం ప్రారంభించండి. మీ రుణాలను వేగంగా తగ్గించండి.",
    "tool.creditCard.title": "క్రెడిట్ కార్డ్ మాస్టర్",
    "tool.creditCard.micro": "రుణ ట్రాప్ సిమ్యులేటర్, CIBIL సూచిక & నిజమైన బహుమతి కాలిక్యులేటర్.",
    "tool.childFuture.title": "పిల్లల భవిష్యత్తు",
    "tool.childFuture.micro": "మీ పిల్లల విద్య కలల కోసం నెలవారీ పొదుపులను ప్లాన్ చేయండి.",
    "tool.canibuyit.title": "నేను ఇది కొనగలనా?",
    "tool.canibuyit.micro": "మీరు నిజంగా దానిని భరించగలరా? అన్ని దాచిన ఖర్చులతో నగదు vs EMI.",
    "tool.emergency.title": "అత్యవసర నిధి",
    "tool.emergency.micro": "మీకు నిజంగా ఎంత భద్రతా వలయం కావాలి? ఇప్పుడు తెలుసుకోండి.",
    "tool.inflation.title": "ద్రవ్యోల్బణ యంత్రం",
    "tool.inflation.micro": "₹100 ₹50 లాగా ఎందుకు అనిపిస్తుంది. మీ సంపదకు నిశ్శబ్ద దొంగ.",
    "tool.compare.title": "ఉత్పత్తి పోలిక",
    "tool.compare.micro": "క్రెడిట్ కార్డులు, పొదుపు ఖాతాలు & బీమాను పక్కపక్కన పోల్చండి.",
    "contact.title": "సహాయం కావాలా? మేము ఇక్కడ ఉన్నాము.",
    "contact.desc": "ప్రశ్నలు, అభిప్రాయం, లేదా కేవలం హాయ్ చెప్పాలనుకుంటున్నారా? ఎప్పుడైనా సంప్రదించండి.",
    "nav.stockLab": "స్టాక్ ల్యాబ్",
    "nav.goalTracker": "లక్ష్యాలు",
    "nav.contact": "సంప్రదించండి",
    "nav.taxPlanner": "పన్ను ప్లానర్",
    "nav.propertyPlanner": "ఆస్తి",
    "footer.terms": "వినియోగ నిబంధనలు",
  },
  ta: {
    "home.toolkitTitle": "உங்கள் முழுமையான நிதி கருவித்தொகுப்பு",
    "home.toolkitSub": "நவீன இந்திய சம்பாதிப்பவர்களுக்கான 12 சக்திவாய்ந்த கருவிகள் — உங்கள் முதல் SIP முதல் ஓய்வூதிய நிதி வரை.",
    "home.catInvest": "💰 முதலீடு & வளர்ச்சி",
    "home.catPlan": "🏠 திட்டம் & பாதுகாப்பு",
    "home.catTax": "📋 வரி & கடன்",
    "home.catLife": "🎯 வாழ்க்கை நிலைகள்",
    "home.toolWealth": "வெல்த் இன்ஜின்",
    "home.toolWealthDesc": "SIP, ஒருமுறை முதலீடு, ஸ்டெப்-அப் & தாமத செலவு — இந்திய முதலீட்டாளர்களுக்கான மிகச்சிறந்த கூட்டு வட்டி கால்குலேட்டர்.",
    "home.toolStock": "பங்கு ஆராய்ச்சி ஆய்வகம்",
    "home.toolStockDesc": "நேரடி சந்தை தரவு, நிறுவன அடிப்படைகள் & TradingView விளக்கப்படங்கள்.",
    "home.toolMultiAsset": "பல-சொத்து ஒப்பீடு",
    "home.toolMultiAssetDesc": "FD, தங்கம், குறியீட்டு & பங்குச் சந்தையில் SIP வளர்ச்சியை ஒப்பிடுங்கள்.",
    "home.toolRealEstate": "ரியல் எஸ்டேட் திட்டமிடுபவர்",
    "home.toolRealEstateDesc": "பட்ஜெட் கால்குலேட்டர், EMI உருவகப்படுத்தி & முத்திரைத் தீர்வு மதிப்பீடு.",
    "home.toolRentBuy": "வாடகை vs வாங்குதல் பகுப்பாய்வி",
    "home.toolRentBuyDesc": "20 ஆண்டு செல்வ ஒப்பீடு: மொத்த உரிமை செலவு vs வாடகை + டவுன் பேமெண்ட் முதலீடு.",
    "home.toolRetirement": "ஓய்வூதிய கடிகாரம்",
    "home.toolRetirementDesc": "வசதியாக ஓய்வு பெற எவ்வளவு தேவை? உங்கள் நிதி & மாதாந்திர SIP கணக்கிடுங்கள்.",
    "home.toolTaxSim": "வரி உருவகப்படுத்தி",
    "home.toolTaxSimDesc": "பழைய vs புதிய முறை ஒப்பீடு — HRA, 80C, NPS & ஃப்ரீலான்சர் 44ADA ஆதரவு.",
    "home.toolDebt": "கடன் கில்லர்",
    "home.toolDebtDesc": "ஸ்னோபால் vs அவலாஞ்ச் உத்திகள் — கடன்களில் எவ்வளவு அதிக வட்டி செலுத்துகிறீர்கள் எனத் தெரிந்துகொள்ளுங்கள்.",
    "home.toolCreditCard": "கிரெடிட் கார்ட் மாஸ்டர்",
    "home.toolCreditCardDesc": "கடன் பொறி உருவகம், CIBIL கணிப்பான் & உண்மையான வெகுமதி கால்குலேட்டர்.",
    "home.toolInflation": "பணவீக்க யதார்த்த இயந்திரம்",
    "home.toolInflationDesc": "இன்றைய ₹1,000 10 ஆண்டுகளில் ₹558 ஆவதைப் பாருங்கள்.",
    "home.toolChildFuture": "குழந்தையின் எதிர்காலத் திட்டமிடுபவர்",
    "home.toolChildFutureDesc": "டாக்டர், IIT, வெளிநாட்டுப் படிப்புக்கான மாதாந்திர SIP ரிவர்ஸ்-இன்ஜினியர் செய்யுங்கள்.",
    "home.toolEMI": "EMI வழிகாட்டி",
    "home.toolEMIDesc": "அந்த வாங்குதல் உண்மையிலேயே முடியுமா? பணம் vs EMI மறைந்த செலவுகள் ஒப்பீடு.",
    "hero.journeyTitle": "இன்றே உங்கள் முதலீட்டு பயணத்தை தொடங்குங்கள்",
    "hero.journeyDesc": "இங்கே கிளிக் செய்யுங்கள் — உங்கள் நிதி பற்றிய சில கேள்விகளுக்கு பதிலளியுங்கள், தனிப்பயன் டாஷ்போர்டு பெறுங்கள்.",
    "hero.journeyCta": "தொடங்க இங்கே கிளிக் செய்யுங்கள் →",
    "home.viewAllTools": "அனைத்து கருவிகளையும் பாருங்கள்",
    "home.whyTitle": "'சாதி' என்பது கருவி மட்டும் அல்ல",
    "home.whySub": "RupeeVikas வெறும் கால்குலேட்டர் அல்ல — இது உங்கள் மொழியில் பேசும் நிதி தோழன்.",
    "home.whyFreeTitle": "100% இலவசம் & தனிப்பட்டது",
    "home.whyFreeDesc": "கருவிகளுக்கு பதிவு தேவையில்லை. உங்கள் தரவு உங்கள் சாதனத்தில் இருக்கும்.",
    "home.whyLangTitle": "13 இந்திய மொழிகள்",
    "home.whyLangDesc": "இந்தியிலிருந்து கன்னடம், தமிழிலிருந்து அசாமீ — நிதி எழுத்தறிவுக்கு மொழி தடை இருக்கக்கூடாது.",
    "home.whyIndiaTitle": "இந்தியாவுக்காக உருவாக்கப்பட்டது",
    "home.whyIndiaDesc": "இந்திய வரி முறைகள், SEBI விதிகள், RBI விகிதங்கள், மற்றும் UPI-யுக கடன் மேலாண்மை.",
    "home.whySathiTitle": "சாதி புத்திசாலித்தனம்",
    "home.whySathiDesc": "ஒவ்வொரு கருவியிலும் சூழல்-சார்ந்த உதவிக்குறிப்புகள் — நிதி அறிவுள்ள நண்பன் பக்கத்தில் இருப்பது போல.",
    "home.statTools": "நிதி கருவிகள்",
    "home.statLangs": "இந்திய மொழிகள்",
    "home.statFree": "எப்போதும் இலவசம்",
    "home.statPrivacy": "தனியுரிமை முதல்",
    "home.footerDisclaimer2": "வழங்கப்பட்ட தரவு கல்வி பயன்பாட்டிற்கு மட்டுமே. அனைத்து வட்டி விகிதங்கள் மற்றும் வரி சட்டங்கள் மார்ச் 2026 வரை புதுப்பிக்கப்பட்டவை.",
    "home.footerIndian": "🇮🇳 100% இந்திய உரிமை — இந்திய வரி முறைகள், ரியல் எஸ்டேட் சட்டங்கள், மற்றும் UPI-அடிப்படையிலான கடன் மேலாண்மை.",
    "nav.stockResearch": "பங்கு ஆராய்ச்சி",
    "explore.title": "அனைத்து கருவிகளையும் ஆராயுங்கள்",
    "explore.subtitle": "உங்கள் முழுமையான நிதி கருவித்தொகுப்பு — கால்குலேட்டர்கள், திட்டமிடுபவர்கள் & ஒப்பீட்டு இயந்திரங்கள்",
    "explore.openTool": "கருவி திற",
    "explore.toolCalc": "முதலீட்டு கால்குலேட்டர்கள்",
    "explore.toolCalcDesc": "SIP, ஒருமுறை முதலீடு, மற்றும் பல கால்குலேட்டர்கள்",
    "explore.toolDebt": "கடன் கில்லர்",
    "explore.toolDebtDesc": "கடனை விரைவாக முடிக்க ஸ்னோபால் vs அவலாஞ்ச் உத்திகள்",
    "explore.toolTaxSim": "வரி உருவகப்படுத்தி",
    "explore.toolTaxSimDesc": "பழைய vs புதிய முறையில் உங்கள் வரி பொறுப்பை உருவகப்படுத்துங்கள்",
    "explore.toolRealEstate": "ரியல் எஸ்டேட் திட்டமிடுபவர்",
    "explore.toolRealEstateDesc": "பட்ஜெட், ROI உருவகம், மற்றும் வாங்கும் திறன் சோதனை",
    "explore.toolRentBuy": "வாடகை vs வாங்குதல் பகுப்பாய்வி",
    "explore.toolRentBuyDesc": "15 ஆண்டு செல்வ கணிப்புடன் வாடகை vs வாங்குதல் ஒப்பீடு",
    "explore.toolRetirement": "ஓய்வூதிய கடிகாரம்",
    "explore.toolRetirementDesc": "ஓய்வூதிய நிதி மற்றும் மாதாந்திர SIP திட்டமிடுங்கள்",
    "explore.toolCompare": "தயாரிப்பு ஒப்பீடு",
    "explore.toolCompareDesc": "கிரெடிட் கார்டுகள், சேமிப்புக் கணக்குகள் & உடல்நலக் காப்பீடு ஒப்பிடுங்கள்",
    "explore.toolEMI": "வாங்கும் திறன் & EMI வழிகாட்டி",
    "explore.toolEMIDesc": "உண்மையிலேயே முடியுமா? பணம் vs EMI மறைந்த செலவுகள் ஒப்பீடு",
    "explore.toolInflation": "பணவீக்க யதார்த்த இயந்திரம்",
    "explore.toolInflationDesc": "பணவீக்கம் எப்படி அமைதியாக உங்கள் சேமிப்பை தின்கிறது பாருங்கள்",
    "explore.toolEmergency": "அவசரகால நிதி சோதனையாளர்",
    "explore.toolEmergencyDesc": "உங்கள் சிறந்த பாதுகாப்பு வலை கணக்கிட வினாடி-வினா அடிப்படையிலான சோதனை",
    "explore.toolChildFuture": "குழந்தையின் எதிர்காலத் திட்டமிடுபவர்",
    "explore.toolChildFutureDesc": "குழந்தையின் கல்வி கனவுக்கு SIP ரிவர்ஸ்-இன்ஜினியர் செய்யுங்கள்",
    "explore.toolCreditCard": "கிரெடிட் கார்ட் மாஸ்டர்",
    "explore.toolCreditCardDesc": "கடன் பொறி உருவகம், CIBIL கணிப்பான் & உண்மையான வெகுமதி கால்குலேட்டர்",
    "explore.toolMultiAsset": "பல-சொத்து ஒப்பீடு",
    "explore.toolMultiAssetDesc": "FD, தங்கம், ரியல் எஸ்டேட், இண்டெக்ஸ் ஃபண்ட் & பங்கு வருமானத்தை ஒப்பிடுங்கள்",
    "explore.toolStock": "பங்கு ஆராய்ச்சி ஆய்வகம்",
    "explore.toolStockDesc": "நேரடி சந்தை தரவு, நிறுவன அடிப்படைகள் & TradingView விளக்கப்படங்கள்",
    "comp.bestFor": "சிறந்தது:",
    "comp.frequentFlyers": "அடிக்கடி பயணிப்பவர்கள்",
    "comp.onlineShoppers": "ஆன்லைன் ஷாப்பர்கள்",
    // Premium redesign keys
    "hero.premiumHeadline": "तुम्ही दररोज श्रीमंत होत आहात की गरीब?",
    "hero.premiumSub": "30 सेकंदात शोधा. तुमचे आर्थिक भविष्य, दृश्यमान केले आहे.",
    "hero.wealthCardTitle": "भविष्य संपत्ती सिम्युलेटर",
    "hero.monthlySavings": "मासिक बचत",
    "hero.premiumCta": "माझा स्वातंत्र्याचा मार्ग दाखवा",
    "cat.all": "सर्व साधने",
    "cat.debt": "कर्जमुक्त मार्ग",
    "cat.invest": "गुंतवणूक करा आणि वाढवा",
    "cat.home": "घर खरेदी करा",
    "cat.kids": "मुलांसाठी योजना",
    "cat.tax": "कर बचत करा",
    "tool.wealth.title": "संपत्ती इंजिन",
    "tool.wealth.micro": "तुमचे SIP किती वेगाने वाढू शकते? चक्रवाढीची जादू कृतीत पहा.",
    "tool.stock.title": "स्टॉक लॅब",
    "tool.stock.micro": "तुमचा आवडता स्टॉक सापळा आहे का? थेट डेटा, चार्ट आणि मूलभूत गोष्टी.",
    "tool.multiAsset.title": "मल्टी-असेट तुलना करा",
    "tool.multiAsset.micro": "FD vs गोल्ड vs स्टॉक vs इंडेक्स — 10 वर्षांत कोण जिंकतो?",
    "tool.realEstate.title": "रिअल इस्टेट प्लॅनर",
    "tool.realEstate.micro": "तुमच्या स्वप्नातील घराची खरी किंमत — EMI, स्टॅम्प ड्युटी आणि छुपे शुल्क.",
    "tool.rentBuy.title": "भाड्याने घ्या की खरेदी करा",
    "tool.rentBuy.micro": "तुमच्या स्वप्नातील घरामागील गणित. तुम्ही भाड्याने घ्यावे की खरेदी करावे?",
    "tool.retirement.title": "सेवानिवृत्ती घड्याळ",
    "tool.retirement.micro": "निवृत्त होण्यासाठी तुम्हाला किती पैसे लागतील? तुमचा जादूचा नंबर शोधा.",
    "tool.taxSim.title": "कर सिम्युलेटर",
    "tool.taxSim.micro": "जुनी विरुद्ध नवीन योजना — कोणती तुम्हाला अधिक बचत करून देते? त्वरित शोधा.",
    "tool.debt.title": "कर्जमुक्त मार्ग",
    "tool.debt.micro": "व्याज देणे थांबवा, जगायला सुरुवात करा. तुमचे कर्ज वेगाने संपवा.",
    "tool.creditCard.title": "क्रेडिट कार्ड मास्टर",
    "tool.creditCard.micro": "कर्ज सापळा सिम्युलेटर, CIBIL भविष्यसूचक आणि वास्तविक बक्षीस कॅल्क्युलेटर.",
    "tool.childFuture.title": "मुलाचे भविष्य",
    "tool.childFuture.micro": "तुमच्या मुलाच्या शैक्षणिक स्वप्नांसाठी मासिक बचतीची योजना करा.",
    "tool.canibuyit.title": "मी हे विकत घेऊ शकतो का?",
    "tool.canibuyit.micro": "तुम्ही ते खरोखर परवडू शकता का? सर्व छुपे खर्चांसह रोख विरुद्ध EMI.",
    "tool.emergency.title": "आणीबाणी निधी",
    "tool.emergency.micro": "तुम्हाला खरोखर किती सुरक्षा जाळ्याची गरज आहे? आता शोधा.",
    "tool.inflation.title": "महागाई मशीन",
    "tool.inflation.micro": "₹100 ₹50 सारखे का वाटते. तुमच्या संपत्तीचा शांत चोर.",
    "tool.compare.title": "उत्पादन तुलना करा",
    "tool.compare.micro": "क्रेडिट कार्ड, बचत खाते आणि विमा बाजू बाजूला तुलना करा.",
    "contact.title": "मदत हवी आहे? आम्ही इथे आहोत.",
    "contact.desc": "प्रश्न, अभिप्राय, किंवा फक्त 'हाय' म्हणायचे आहे? कधीही संपर्क साधा.",
    "nav.stockLab": "स्टॉक लॅब",
    "nav.goalTracker": "ध्येये",
    "nav.contact": "संपर्क",
    "footer.terms": "वापरण्याच्या अटी",
  },
  mr: {
    "nav.taxPlanner": "कर नियोजक",
    "nav.propertyPlanner": "मालमत्ता",
    "home.toolkitTitle": "तुमचे संपूर्ण आर्थिक टूलकिट",
    "home.toolkitSub": "आधुनिक भारतीय कमावत्या लोकांसाठी 12 शक्तिशाली साधने — तुमच्या पहिल्या SIP पासून रिटायरमेंट कॉर्पसपर्यंत.",
    "home.catInvest": "💰 गुंतवणूक आणि वाढ",
    "home.catPlan": "🏠 नियोजन आणि संरक्षण",
    "home.catTax": "📋 टॅक्स आणि कर्ज",
    "home.catLife": "🎯 जीवनाचे टप्पे",
    "home.toolWealth": "वेल्थ इंजिन",
    "home.toolWealthDesc": "SIP, एकरकमी, स्टेप-अप आणि विलंबाची किंमत — भारतीय गुंतवणूकदारांसाठी सर्वात शक्तिशाली कंपाउंडिंग कॅल्क्युलेटर.",
    "home.toolStock": "स्टॉक रिसर्च लॅब",
    "home.toolStockDesc": "लाइव्ह मार्केट डेटा, कंपनी फंडामेंटल्स आणि TradingView चार्ट.",
    "home.toolMultiAsset": "मल्टी-ॲसेट तुलना",
    "home.toolMultiAssetDesc": "FD, सोने, इंडेक्स आणि इक्विटीमध्ये SIP वाढ तुलना करा.",
    "home.toolRealEstate": "रिअल इस्टेट प्लॅनर",
    "home.toolRealEstateDesc": "बजेट कॅल्क्युलेटर, EMI सिम्युलेटर आणि स्टॅम्प ड्यूटी अंदाज.",
    "home.toolRentBuy": "भाडे vs खरेदी विश्लेषक",
    "home.toolRentBuyDesc": "20 वर्षांची संपत्ती तुलना: एकूण मालकी खर्च vs भाडे + डाउन पेमेंट गुंतवणूक.",
    "home.toolRetirement": "रिटायरमेंट क्लॉक",
    "home.toolRetirementDesc": "आरामात रिटायर होण्यासाठी किती लागेल? तुमचा कॉर्पस आणि मासिक SIP मोजा.",
    "home.toolTaxSim": "टॅक्स सिम्युलेटर",
    "home.toolTaxSimDesc": "जुनी vs नवी रिजीम तुलना — HRA, 80C, NPS आणि फ्रीलान्सर 44ADA सपोर्ट.",
    "home.toolDebt": "कर्ज किलर",
    "home.toolDebtDesc": "स्नोबॉल vs अवलांच रणनीती — लोनवर किती जास्त व्याज भरत आहात ते शोधा.",
    "home.toolCreditCard": "क्रेडिट कार्ड मास्टर",
    "home.toolCreditCardDesc": "कर्ज जाळे सिम्युलेटर, CIBIL प्रेडिक्टर आणि ट्रू रिवॉर्ड कॅल्क्युलेटर.",
    "home.toolInflation": "महागाई रिअॅलिटी मशीन",
    "home.toolInflationDesc": "आजचे ₹1,000 10 वर्षांत ₹558 कसे होतात ते पहा.",
    "home.toolChildFuture": "मुलाचे भविष्य प्लॅनर",
    "home.toolChildFutureDesc": "डॉक्टर, IIT, परदेशी शिक्षणासाठी मासिक SIP रिव्हर्स-इंजिनिअर करा.",
    "home.toolEMI": "EMI मेंटर",
    "home.toolEMIDesc": "ती खरेदी खरोखरच शक्य आहे का? कॅश vs EMI लपलेल्या खर्चांची तुलना.",
    "hero.journeyTitle": "आजच तुमचा गुंतवणूक प्रवास सुरू करा",
    "hero.journeyDesc": "इथे क्लिक करा — तुमच्या आर्थिक बाबतीतल्या काही प्रश्नांची उत्तरे द्या, वैयक्तिक डॅशबोर्ड मिळवा.",
    "hero.journeyCta": "सुरू करण्यासाठी इथे क्लिक करा →",
    "home.viewAllTools": "सर्व टूल्स पहा",
    "home.whyTitle": "'साथी' म्हणजे फक्त टूल नाही",
    "home.whySub": "RupeeVikas फक्त कॅल्क्युलेटर नाही — तुमच्या भाषेत बोलणारा आणि भारतीय पैसे समजणारा तुमचा आर्थिक साथीदार.",
    "home.whyFreeTitle": "100% मोफत आणि खाजगी",
    "home.whyFreeDesc": "टूल्ससाठी साइन-अप आवश्यक नाही. तुमचा डेटा तुमच्या डिव्हाइसवर राहतो.",
    "home.whyLangTitle": "13 भारतीय भाषा",
    "home.whyLangDesc": "हिंदीपासून कन्नड, तमिळपासून आसामी — आर्थिक साक्षरतेला भाषेचा अडथळा नसावा.",
    "home.whyIndiaTitle": "भारतासाठी बनवले",
    "home.whyIndiaDesc": "भारतीय टॅक्स रिजीम, SEBI नियम, RBI दर, आणि UPI-युग कर्ज व्यवस्थापन.",
    "home.whySathiTitle": "साथी बुद्धिमत्ता",
    "home.whySathiDesc": "प्रत्येक टूलसोबत संदर्भ-आधारित सल्ले — आर्थिकदृष्ट्या हुशार मित्र तुमच्यासोबत असल्यासारखे.",
    "home.statTools": "आर्थिक साधने",
    "home.statLangs": "भारतीय भाषा",
    "home.statFree": "कायम मोफत",
    "home.statPrivacy": "गोपनीयता प्रथम",
    "home.footerDisclaimer2": "प्रदान केलेला डेटा केवळ शैक्षणिक वापरासाठी आहे. सर्व व्याजदर आणि कर कायदे मार्च 2026 पर्यंत अपडेट.",
    "home.footerIndian": "🇮🇳 100% भारतीय-मालकी — भारतीय टॅक्स रिजीम, रिअल इस्टेट कायदे, आणि UPI-आधारित कर्ज व्यवस्थापनावर लक्ष.",
    "nav.stockResearch": "स्टॉक रिसर्च",
    "explore.title": "सर्व टूल्स एक्सप्लोर करा",
    "explore.subtitle": "तुमचे संपूर्ण आर्थिक टूलकिट — कॅल्क्युलेटर, प्लॅनर आणि तुलना इंजिन",
    "explore.openTool": "टूल उघडा",
    "explore.toolCalc": "गुंतवणूक कॅल्क्युलेटर",
    "explore.toolCalcDesc": "SIP, एकरकमी, आणि अधिक गुंतवणूक कॅल्क्युलेटर",
    "explore.toolDebt": "कर्ज किलर",
    "explore.toolDebtDesc": "कर्ज लवकर संपवण्यासाठी स्नोबॉल vs अवलांच रणनीती",
    "explore.toolTaxSim": "टॅक्स सिम्युलेटर",
    "explore.toolTaxSimDesc": "जुन्या vs नव्या रिजीममध्ये तुमची टॅक्स देणी सिम्युलेट करा",
    "explore.toolRealEstate": "रिअल इस्टेट प्लॅनर",
    "explore.toolRealEstateDesc": "बजेट, ROI सिम्युलेटर, आणि परवडणूक तपासणी",
    "explore.toolRentBuy": "भाडे vs खरेदी विश्लेषक",
    "explore.toolRentBuyDesc": "15 वर्षांच्या संपत्ती प्रक्षेपणासह भाडे vs खरेदी तुलना",
    "explore.toolRetirement": "रिटायरमेंट क्लॉक",
    "explore.toolRetirementDesc": "रिटायरमेंट कॉर्पस आणि मासिक SIP प्लॅन करा",
    "explore.toolCompare": "उत्पादन तुलना",
    "explore.toolCompareDesc": "क्रेडिट कार्ड, बचत खाती आणि आरोग्य विमा तुलना करा",
    "explore.toolEMI": "परवडणूक आणि EMI मेंटर",
    "explore.toolEMIDesc": "खरोखरच शक्य आहे? कॅश vs EMI लपलेल्या खर्चांची तुलना",
    "explore.toolInflation": "महागाई रिअॅलिटी मशीन",
    "explore.toolInflationDesc": "महागाई कशी गुपचूप तुमची बचत खाते ते पहा",
    "explore.toolEmergency": "इमर्जन्सी फंड टेस्टर",
    "explore.toolEmergencyDesc": "तुमचे आदर्श सेफ्टी नेट मोजण्यासाठी क्विझ-आधारित स्ट्रेस टेस्ट",
    "explore.toolChildFuture": "मुलाचे भविष्य प्लॅनर",
    "explore.toolChildFutureDesc": "मुलाच्या शिक्षणाच्या स्वप्नासाठी SIP रिव्हर्स-इंजिनिअर करा",
    "explore.toolCreditCard": "क्रेडिट कार्ड मास्टर",
    "explore.toolCreditCardDesc": "कर्ज जाळे सिम्युलेटर, CIBIL प्रेडिक्टर आणि ट्रू रिवॉर्ड कॅल्क्युलेटर",
    "explore.toolMultiAsset": "मल्टी-ॲसेट तुलना",
    "explore.toolMultiAssetDesc": "FD, सोने, रिअल इस्टेट, इंडेक्स फंड आणि स्टॉक रिटर्न्स तुलना करा",
    "explore.toolStock": "स्टॉक रिसर्च लॅब",
    "explore.toolStockDesc": "लाइव्ह मार्केट डेटा, कंपनी फंडामेंटल्स आणि TradingView चार्ट",
    "comp.bestFor": "यासाठी सर्वोत्तम:",
    "comp.frequentFlyers": "वारंवार प्रवासी",
    "comp.onlineShoppers": "ऑनलाइन खरेदीदार",
    // Premium redesign keys
    "hero.premiumHeadline": "நீங்கள் ஒவ்வொரு நாளும் பணக்காரராகிறீர்களா அல்லது ஏழையாகிறீர்களா?",
    "hero.premiumSub": "30 வினாடிகளில் கண்டறியவும். உங்கள் நிதி எதிர்காலம், காட்சிப்படுத்தப்பட்டது.",
    "hero.wealthCardTitle": "வருங்கால செல்வச் சிமுலேட்டர்",
    "hero.monthlySavings": "மாதாந்திர சேமிப்பு",
    "hero.premiumCta": "சுதந்திரத்திற்கான எனது பாதையைக் காட்டு",
    "cat.all": "அனைத்து கருவிகள்",
    "cat.debt": "கடன் இல்லாத பாதை",
    "cat.invest": "முதலீடு செய்து வளரவும்",
    "cat.home": "ஒரு வீடு வாங்கவும்",
    "cat.kids": "குழந்தைகளுக்கான திட்டம்",
    "cat.tax": "வரி சேமியுங்கள்",
    "tool.wealth.title": "செல்வம் எஞ்சின்",
    "tool.wealth.micro": "உங்கள் SIP எவ்வளவு வேகமாக வளர முடியும்? கூட்டு வட்டியின் மாயாஜாலத்தைப் பாருங்கள்.",
    "tool.stock.title": "பங்கு ஆய்வுக்கூடம்",
    "tool.stock.micro": "உங்களுக்கு பிடித்த பங்கு ஒரு வலையா? நேரடி தரவு, விளக்கப்படங்கள் & அடிப்படைகள்.",
    "tool.multiAsset.title": "பல-சொத்து ஒப்பீடு",
    "tool.multiAsset.micro": "FD vs தங்கம் vs பங்குகள் vs குறியீடு — 10 ஆண்டுகளில் யார் வெற்றி பெறுவார்கள்?",
    "tool.realEstate.title": "ரியல் எஸ்டேட் திட்டமிடுபவர்",
    "tool.realEstate.micro": "உங்கள் கனவு இல்லத்தின் உண்மையான செலவு — EMI, முத்திரைத் தீர்வை & மறைக்கப்பட்ட கட்டணங்கள்.",
    "tool.rentBuy.title": "வாடகை vs வாங்குதல்",
    "tool.rentBuy.micro": "உங்கள் கனவு இல்லத்திற்குப் பின்னால் உள்ள கணிதம். நீங்கள் வாடகைக்கு எடுக்க வேண்டுமா அல்லது வாங்க வேண்டுமா?",
    "tool.retirement.title": "ஓய்வூதியக் கடிகாரம்",
    "tool.retirement.micro": "ஓய்வு பெற உங்களுக்கு எவ்வளவு தேவை? உங்கள் மாயாஜால எண்ணைக் கண்டறியவும்.",
    "tool.taxSim.title": "வரி சிமுலேட்டர்",
    "tool.taxSim.micro": "பழைய vs புதிய ஆட்சி — எது உங்களுக்கு அதிகம் சேமிக்கிறது? உடனடியாகக் கண்டறியவும்.",
    "tool.debt.title": "கடன் இல்லாத பாதை",
    "tool.debt.micro": "வட்டி செலுத்துவதை நிறுத்துங்கள், வாழத் தொடங்குங்கள். உங்கள் கடன்களை விரைவாக நசுக்குங்கள்.",
    "tool.creditCard.title": "கிரெடிட் கார்டு மாஸ்டர்",
    "tool.creditCard.micro": "கடன் பொறி சிமுலேட்டர், CIBIL முன்னறிவிப்பு & உண்மையான வெகுமதி கால்குலேட்டர்.",
    "tool.childFuture.title": "குழந்தையின் எதிர்காலம்",
    "tool.childFuture.micro": "உங்கள் குழந்தையின் கல்வி கனவுகளுக்காக மாதாந்திர சேமிப்பைத் திட்டமிடுங்கள்.",
    "tool.canibuyit.title": "நான் இதை வாங்கலாமா?",
    "tool.canibuyit.micro": "உங்களால் இதை உண்மையிலேயே வாங்க முடியுமா? அனைத்து மறைக்கப்பட்ட செலவுகளுடன் ரொக்கம் vs EMI.",
    "tool.emergency.title": "அவசர நிதி",
    "tool.emergency.micro": "உங்களுக்கு உண்மையில் எவ்வளவு பாதுகாப்பான வலை தேவை? இப்போது கண்டறியவும்.",
    "tool.inflation.title": "பணவீக்க இயந்திரம்",
    "tool.inflation.micro": "₹100 ஏன் ₹50 போல் உணர்கிறது. உங்கள் செல்வத்தின் மௌனத் திருடன்.",
    "tool.compare.title": "தயாரிப்பு ஒப்பீடு",
    "tool.compare.micro": "கிரெடிட் கார்டுகள், சேமிப்புக் கணக்குகள் & காப்பீட்டை ஒப்பிடுங்கள்.",
    "contact.title": "உதவி தேவையா? நாங்கள் இங்கே இருக்கிறோம்.",
    "contact.desc": "கேள்விகள், கருத்து, அல்லது வணக்கம் சொல்ல வேண்டுமா? எந்த நேரத்திலும் தொடர்பு கொள்ளுங்கள்.",
    "nav.stockLab": "பங்கு ஆய்வுக்கூடம்",
    "nav.goalTracker": "இலக்குகள்",
    "nav.contact": "தொடர்பு",
    "footer.terms": "பயன்பாட்டு நிபந்தனைகள்",
  },
  gu: {
    "home.toolkitTitle": "તમારું સંપૂર્ણ નાણાકીય ટૂલકિટ",
    "nav.taxPlanner": "வரி திட்டமிடல்",
    "nav.propertyPlanner": "சொத்து",
    "home.toolkitSub": "આધુનિક ભારતીય કમાણી કરનારાઓ માટે 12 શક્તિશાળી ટૂલ્સ — તમારા પહેલા SIP થી નિવૃત્તિ કોર્પસ સુધી.",
    "home.catInvest": "💰 રોકાણ અને વૃદ્ધિ",
    "home.catPlan": "🏠 આયોજન અને સુરક્ષા",
    "home.catTax": "📋 ટેક્સ અને દેવું",
    "home.catLife": "🎯 જીવનના તબક્કા",
    "home.toolWealth": "વેલ્થ એન્જિન",
    "home.toolWealthDesc": "SIP, એકમુશ્ત, સ્ટેપ-અપ અને વિલંબનો ખર્ચ — ભારતીય રોકાણકારો માટે સૌથી શક્તિશાળી કમ્પાઉન્ડિંગ કેલ્ક્યુલેટર.",
    "home.toolStock": "સ્ટોક રિસર્ચ લેબ",
    "home.toolStockDesc": "લાઈવ માર્કેટ ડેટા, કંપની ફંડામેન્ટલ્સ અને TradingView ચાર્ટ્સ.",
    "home.toolMultiAsset": "મલ્ટી-એસેટ સરખામણી",
    "home.toolMultiAssetDesc": "FD, સોનું, ઇન્ડેક્સ અને ઇક્વિટીમાં SIP વૃદ્ધિ સરખાવો.",
    "home.toolRealEstate": "રિયલ એસ્ટેટ પ્લાનર",
    "home.toolRealEstateDesc": "બજેટ કેલ્ક્યુલેટર, EMI સિમ્યુલેટર અને સ્ટેમ્પ ડ્યુટી અંદાજ.",
    "home.toolRentBuy": "ભાડું vs ખરીદી વિશ્લેષક",
    "home.toolRentBuyDesc": "20 વર્ષની સંપત્તિ સરખામણી: કુલ માલિકી ખર્ચ vs ભાડું + ડાઉન પેમેન્ટ રોકાણ.",
    "home.toolRetirement": "નિવૃત્તિ ઘડિયાળ",
    "home.toolRetirementDesc": "આરામથી નિવૃત્ત થવા માટે કેટલું જોઈએ? તમારો કોર્પસ અને માસિક SIP ગણો.",
    "home.toolTaxSim": "ટેક્સ સિમ્યુલેટર",
    "home.toolTaxSimDesc": "જૂની vs નવી રીજિમ સરખામણી — HRA, 80C, NPS અને ફ્રીલાન્સર 44ADA સપોર્ટ.",
    "home.toolDebt": "દેવું કિલર",
    "home.toolDebtDesc": "સ્નોબોલ vs એવલાંચ વ્યૂહરચના — લોન પર કેટલું વધારે વ્યાજ ચૂકવો છો તે જાણો.",
    "home.toolCreditCard": "ક્રેડિટ કાર્ડ માસ્ટર",
    "home.toolCreditCardDesc": "દેવા જાળ સિમ્યુલેટર, CIBIL પ્રેડિક્ટર અને ટ્રુ રિવોર્ડ કેલ્ક્યુલેટર.",
    "home.toolInflation": "મોંઘવારી રિયાલિટી મશીન",
    "home.toolInflationDesc": "આજના ₹1,000 10 વર્ષમાં ₹558 કેવી રીતે થાય છે તે જુઓ.",
    "home.toolChildFuture": "બાળકનું ભવિષ્ય પ્લાનર",
    "home.toolChildFutureDesc": "ડૉક્ટર, IIT, વિદેશ અભ્યાસ માટે માસિક SIP રિવર્સ-એન્જિનિયર કરો.",
    "home.toolEMI": "EMI મેન્ટર",
    "home.toolEMIDesc": "તે ખરીદી ખરેખર શક્ય છે? કેશ vs EMI છુપાયેલા ખર્ચની સરખામણી.",
    "hero.journeyTitle": "આજે જ તમારી રોકાણ યાત્રા શરૂ કરો",
    "hero.journeyDesc": "અહીં ક્લિક કરો — તમારા નાણાં વિશે થોડા પ્રશ્નોના જવાબ આપો, વ્યક્તિગત ડેશબોર્ડ મેળવો.",
    "hero.journeyCta": "શરૂ કરવા અહીં ક્લિક કરો →",
    "home.viewAllTools": "બધા ટૂલ્સ જુઓ",
    "home.whyTitle": "'સાથી' એટલે માત્ર ટૂલ નથી",
    "home.whySub": "RupeeVikas માત્ર કેલ્ક્યુલેટર નથી — તમારી ભાષામાં બોલતો નાણાકીય સાથી છે.",
    "home.whyFreeTitle": "100% મફત અને ખાનગી",
    "home.whyFreeDesc": "ટૂલ્સ માટે સાઇન-અપ જરૂરી નથી. તમારો ડેટા તમારા ડિવાઇસ પર રહે છે.",
    "home.whyLangTitle": "13 ભારતીય ભાષાઓ",
    "home.whyLangDesc": "હિન્દીથી કન્નડ, તમિલથી આસામી — નાણાકીય સાક્ષરતામાં ભાષાનો અવરોધ ન હોવો જોઈએ.",
    "home.whyIndiaTitle": "ભારત માટે બનાવેલ",
    "home.whyIndiaDesc": "ભારતીય ટેક્સ રીજિમ, SEBI નિયમો, RBI દર, અને UPI-યુગ દેવું વ્યવસ્થાપન.",
    "home.whySathiTitle": "સાથી બુદ્ધિમત્તા",
    "home.whySathiDesc": "દરેક ટૂલ સાથે સંદર્ભ-આધારિત સલાહ — નાણાકીય સમજદાર મિત્ર પાસે હોય તેવું.",
    "home.statTools": "નાણાકીય ટૂલ્સ",
    "home.statLangs": "ભારતીય ભાષાઓ",
    "home.statFree": "હંમેશા મફત",
    "home.statPrivacy": "ગોપનીયતા પ્રથમ",
    "home.footerDisclaimer2": "આપેલ ડેટા માત્ર શૈક્ષણિક ઉપયોગ માટે છે. બધા વ્યાજ દર અને કર કાયદા માર્ચ 2026 સુધી અપડેટ.",
    "home.footerIndian": "🇮🇳 100% ભારતીય-માલિકી — ભારતીય ટેક્સ રીજિમ, રિયલ એસ્ટેટ કાયદા, અને UPI-આધારિત દેવું વ્યવસ્થાપન.",
    "nav.stockResearch": "સ્ટોક રિસર્ચ",
    "explore.title": "બધા ટૂલ્સ શોધો",
    "explore.subtitle": "તમારું સંપૂર્ણ નાણાકીય ટૂલકિટ — કેલ્ક્યુલેટર, પ્લાનર અને સરખામણી એન્જિન",
    "explore.openTool": "ટૂલ ખોલો",
    "explore.toolCalc": "રોકાણ કેલ્ક્યુલેટર",
    "explore.toolCalcDesc": "SIP, એકમુશ્ત, અને વધુ રોકાણ કેલ્ક્યુલેટર",
    "explore.toolDebt": "દેવું કિલર",
    "explore.toolDebtDesc": "દેવું ઝડપથી ખતમ કરવા સ્નોબોલ vs એવલાંચ વ્યૂહરચના",
    "explore.toolTaxSim": "ટેક્સ સિમ્યુલેટર",
    "explore.toolTaxSimDesc": "જૂની vs નવી રીજિમમાં તમારી ટેક્સ જવાબદારી સિમ્યુલેટ કરો",
    "explore.toolRealEstate": "રિયલ એસ્ટેટ પ્લાનર",
    "explore.toolRealEstateDesc": "બજેટ, ROI સિમ્યુલેટર, અને પરવડે તેવું ચકાસણી",
    "explore.toolRentBuy": "ભાડું vs ખરીદી વિશ્લેષક",
    "explore.toolRentBuyDesc": "15 વર્ષની સંપત્તિ અંદાજ સાથે ભાડું vs ખરીદી સરખામણી",
    "explore.toolRetirement": "નિવૃત્તિ ઘડિયાળ",
    "explore.toolRetirementDesc": "નિવૃત્તિ કોર્પસ અને માસિક SIP આયોજન કરો",
    "explore.toolCompare": "ઉત્પાદન સરખામણી",
    "explore.toolCompareDesc": "ક્રેડિટ કાર્ડ, બચત ખાતા અને સ્વાસ્થ્ય વીમા સરખાવો",
    "explore.toolEMI": "પરવડે તેવું અને EMI મેન્ટર",
    "explore.toolEMIDesc": "ખરેખર શક્ય? કેશ vs EMI છુપાયેલા ખર્ચ સરખામણી",
    "explore.toolInflation": "મોંઘવારી રિયાલિટી મશીન",
    "explore.toolInflationDesc": "મોંઘવારી કેવી રીતે ચુપચાપ તમારી બચત ખાય છે જુઓ",
    "explore.toolEmergency": "ઇમર્જન્સી ફંડ ટેસ્ટર",
    "explore.toolEmergencyDesc": "તમારું આદર્શ સેફ્ટી નેટ ગણવા ક્વિઝ-આધારિત સ્ટ્રેસ ટેસ્ટ",
    "explore.toolChildFuture": "બાળકનું ભવિષ્ય પ્લાનર",
    "explore.toolChildFutureDesc": "બાળકના શિક્ષણના સ્વપ્ન માટે SIP રિવર્સ-એન્જિનિયર કરો",
    "explore.toolCreditCard": "ક્રેડિટ કાર્ડ માસ્ટર",
    "explore.toolCreditCardDesc": "દેવા જાળ સિમ્યુલેટર, CIBIL પ્રેડિક્ટર અને ટ્રુ રિવોર્ડ કેલ્ક્યુલેટર",
    "explore.toolMultiAsset": "મલ્ટી-એસેટ સરખામણી",
    "explore.toolMultiAssetDesc": "FD, સોનું, રિયલ એસ્ટેટ, ઇન્ડેક્સ ફંડ અને સ્ટોક રિટર્ન સરખાવો",
    "explore.toolStock": "સ્ટોક રિસર્ચ લેબ",
    "explore.toolStockDesc": "લાઈવ માર્કેટ ડેટા, કંપની ફંડામેન્ટલ્સ અને TradingView ચાર્ટ્સ",
    "comp.bestFor": "આ માટે શ્રેષ્ઠ:",
    "comp.frequentFlyers": "વારંવાર મુસાફરી કરનાર",
    "comp.onlineShoppers": "ઓનલાઈન ખરીદદાર",
    // Premium redesign keys
    "hero.premiumHeadline": "તમે દરરોજ શ્રીમંત બની રહ્યા છો કે ગરીબ?",
    "hero.premiumSub": "30 સેકન્ડમાં શોધો. તમારું નાણાકીય ભવિષ્ય, દર્શાવેલ.",
    "hero.wealthCardTitle": "ભવિષ્ય સંપત્તિ સિમ્યુલેટર",
    "hero.monthlySavings": "માસિક બચત",
    "hero.premiumCta": "મારી સ્વતંત્રતાનો માર્ગ બતાવો",
    "cat.all": "બધા સાધનો",
    "cat.debt": "દેવું-મુક્ત માર્ગ",
    "cat.invest": "રોકાણ કરો અને વૃદ્ધિ કરો",
    "cat.home": "ઘર ખરીદો",
    "cat.kids": "બાળકો માટે યોજના",
    "cat.tax": "ટેક્સ બચાવો",
    "tool.wealth.title": "સંપત્તિ એન્જિન",
    "tool.wealth.micro": "તમારી SIP કેટલી ઝડપથી વધી શકે છે? ચક્રવૃદ્ધિનો જાદુ જુઓ.",
    "tool.stock.title": "સ્ટોક લેબ",
    "tool.stock.micro": "શું તમારો પ્રિય સ્ટોક એક ફસકી છે? લાઇવ ડેટા, ચાર્ટ્સ અને મૂળભૂત બાબતો.",
    "tool.multiAsset.title": "મલ્ટી-એસેટ સરખામણી",
    "tool.multiAsset.micro": "FD vs ગોલ્ડ vs સ્ટોક્સ vs ઇન્ડેક્સ — 10 વર્ષમાં કોણ જીતે છે?",
    "tool.realEstate.title": "રીઅલ એસ્ટેટ પ્લાનર",
    "tool.realEstate.micro": "તમારા સ્વપ્ન ઘરની સાચી કિંમત — EMI, સ્ટેમ્પ ડ્યુટી અને છુપાયેલા શુલ્ક.",
    "tool.rentBuy.title": "ભાડે લો કે ખરીદો",
    "tool.rentBuy.micro": "તમારા સ્વપ્ન ઘર પાછળનું ગણિત. તમારે ભાડે લેવું જોઈએ કે ખરીદવું જોઈએ?",
    "tool.retirement.title": "નિવૃત્તિ ઘડિયાળ",
    "tool.retirement.micro": "નિવૃત્ત થવા માટે તમને કેટલા પૈસાની જરૂર છે? તમારો જાદુઈ નંબર શોધો.",
    "tool.taxSim.title": "ટેક્સ સિમ્યુલેટર",
    "tool.taxSim.micro": "જૂની vs નવી શાસન — કયું તમને વધુ બચાવે છે? તરત જ શોધો.",
    "tool.debt.title": "દેવું-મુક્ત માર્ગ",
    "tool.debt.micro": "વ્યાજ ચૂકવવાનું બંધ કરો, જીવવાનું શરૂ કરો. તમારા દેવાંને ઝડપથી કચડી નાખો.",
    "tool.creditCard.title": "ક્રેડિટ કાર્ડ માસ્ટર",
    "tool.creditCard.micro": "દેવું ફસકુ સિમ્યુલેટર, CIBIL ભવિષ્યવાણી અને સાચા ઇનામ કેલ્ક્યુલેટર.",
    "tool.childFuture.title": "બાળકનું ભવિષ્ય",
    "tool.childFuture.micro": "તમારા બાળકના શિક્ષણના સપના માટે માસિક બચતનું આયોજન કરો.",
    "tool.canibuyit.title": "શું હું આ ખરીદી શકું?",
    "tool.canibuyit.micro": "શું તમે ખરેખર તે પરવડી શકો છો? બધા છુપાયેલા ખર્ચ સાથે રોકડ vs EMI.",
    "tool.emergency.title": "ઇમરજન્સી ફંડ",
    "tool.emergency.micro": "તમને ખરેખર કેટલી સલામતી જાળની જરૂર છે? અત્યારે શોધો.",
    "tool.inflation.title": "ફુગાવા મશીન",
    "tool.inflation.micro": "₹100 ₹50 જેવું કેમ લાગે છે. તમારા ધનનો શાંત ચોર.",
    "tool.compare.title": "ઉત્પાદન સરખામણી",
    "tool.compare.micro": "ક્રેડિટ કાર્ડ્સ, બચત ખાતાઓ અને વીમાની બાજુમાં સરખામણી કરો.",
    "contact.title": "મદદ જોઈએ છે? અમે અહીં છીએ.",
    "contact.desc": "પ્રશ્નો, પ્રતિસાદ, અથવા ફક્ત 'હાય' કહેવા માંગો છો? જ્યારે પણ સંપર્ક કરો.",
    "nav.stockLab": "સ્ટોક લેબ",
    "nav.goalTracker": "લક્ષ્યો",
    "nav.contact": "સંપર્ક",
    "footer.terms": "ઉપયોગની શરતો",
  },
  ml: {
    "home.toolkitTitle": "നിങ്ങളുടെ സമ്പൂർണ്ണ സാമ്പത്തിക ടൂൾക്കിറ്റ്",
    "home.toolkitSub": "ആധുനിക ഇന്ത്യൻ സമ്പാദിക്കുന്നവർക്ക് 12 ശക്തമായ ടൂളുകൾ — നിങ്ങളുടെ ആദ്യ SIP മുതൽ വിരമിക്കൽ കോർപ്പസ് വരെ.",
    "nav.taxPlanner": "કર આયોજક",
    "nav.propertyPlanner": "મિલકત",
    "home.catInvest": "💰 നിക്ഷേപം & വളർച്ച",
    "home.catPlan": "🏠 ആസൂത്രണം & സംരക്ഷണം",
    "home.catTax": "📋 നികുതി & കടം",
    "home.catLife": "🎯 ജീവിത ഘട്ടങ്ങൾ",
    "home.toolWealth": "വെൽത്ത് എൻജിൻ",
    "home.toolWealthDesc": "SIP, ലം‌പ്‌സം, സ്റ്റെപ്പ്-അപ്പ് & കാലതാമസ ചെലവ് — ഇന്ത്യൻ നിക്ഷേപകർക്കുള്ള ശക്തമായ കമ്പൗണ്ടിംഗ് കാൽക്കുലേറ്റർ.",
    "home.toolStock": "സ്റ്റോക്ക് റിസർച്ച് ലാബ്",
    "home.toolStockDesc": "ലൈവ് മാർക്കറ്റ് ഡാറ്റ, കമ്പനി അടിസ്ഥാനങ്ങൾ & TradingView ചാർട്ടുകൾ.",
    "home.toolMultiAsset": "മൾട്ടി-ആസ്സറ്റ് താരതമ്യം",
    "home.toolMultiAssetDesc": "FD, സ്വർണ്ണം, ഇൻഡക്സ് & ഇക്വിറ്റിയിൽ SIP വളർച്ച താരതമ്യം ചെയ്യുക.",
    "home.toolRealEstate": "റിയൽ എസ്റ്റേറ്റ് പ്ലാനർ",
    "home.toolRealEstateDesc": "ബജറ്റ് കാൽക്കുലേറ്റർ, EMI സിമുലേറ്റർ & സ്റ്റാമ്പ് ഡ്യൂട്ടി അനുമാനം.",
    "home.toolRentBuy": "വാടക vs വാങ്ങൽ വിശകലനം",
    "home.toolRentBuyDesc": "20 വർഷ സമ്പത്ത് താരതമ്യം: ആകെ ഉടമസ്ഥത ചെലവ് vs വാടക + ഡൗൺ പേമെന്റ് നിക്ഷേപം.",
    "home.toolRetirement": "വിരമിക്കൽ ഘടികാരം",
    "home.toolRetirementDesc": "സുഖകരമായി വിരമിക്കാൻ എത്ര വേണം? നിങ്ങളുടെ കോർപ്പസ് & മാസ SIP കണക്കാക്കുക.",
    "home.toolTaxSim": "നികുതി സിമുലേറ്റർ",
    "home.toolTaxSimDesc": "പഴയ vs പുതിയ രീതി താരതമ്യം — HRA, 80C, NPS & ഫ്രീലാൻസർ 44ADA സപ്പോർട്ട്.",
    "home.toolDebt": "കടം കൊലയാളി",
    "home.toolDebtDesc": "സ്നോബോൾ vs അവലാഞ്ച് തന്ത്രങ്ങൾ — ലോണുകളിൽ എത്ര അധിക പലിശ നൽകുന്നുവെന്ന് അറിയുക.",
    "home.toolCreditCard": "ക്രെഡിറ്റ് കാർഡ് മാസ്റ്റർ",
    "home.toolCreditCardDesc": "കടം കെണി സിമുലേറ്റർ, CIBIL പ്രെഡിക്ടർ & ട്രൂ റിവാർഡ് കാൽക്കുലേറ്റർ.",
    "home.toolInflation": "പണപ്പെരുപ്പ യാഥാർത്ഥ്യ യന്ത്രം",
    "home.toolInflationDesc": "ഇന്നത്തെ ₹1,000 10 വർഷത്തിൽ ₹558 ആകുന്നത് കാണുക.",
    "home.toolChildFuture": "കുട്ടിയുടെ ഭാവി പ്ലാനർ",
    "home.toolChildFutureDesc": "ഡോക്ടർ, IIT, വിദേശ പഠനത്തിന് മാസ SIP റിവേഴ്സ്-എൻജിനീയർ ചെയ്യുക.",
    "home.toolEMI": "EMI മെന്റർ",
    "home.toolEMIDesc": "ആ വാങ്ങൽ ശരിക്കും സാധ്യമാണോ? ക്യാഷ് vs EMI മറഞ്ഞ ചെലവുകൾ താരതമ്യം.",
    "hero.journeyTitle": "ഇന്ന് തന്നെ നിങ്ങളുടെ നിക്ഷേപ യാത്ര ആരംഭിക്കുക",
    "hero.journeyDesc": "ഇവിടെ ക്ലിക്ക് ചെയ്യുക — നിങ്ങളുടെ ധനകാര്യത്തെക്കുറിച്ച് ചില ചോദ്യങ്ങൾക്ക് ഉത്തരം നൽകുക, വ്യക്തിഗത ഡാഷ്‌ബോർഡ് നേടുക.",
    "hero.journeyCta": "ആരംഭിക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക →",
    "home.viewAllTools": "എല്ലാ ടൂളുകളും കാണുക",
    "home.whyTitle": "'സാഥി' എന്നാൽ ഒരു ടൂൾ മാത്രമല്ല",
    "home.whySub": "RupeeVikas വെറും കാൽക്കുലേറ്റർ അല്ല — നിങ്ങളുടെ ഭാഷയിൽ സംസാരിക്കുന്ന സാമ്പത്തിക സഹചാരി.",
    "home.whyFreeTitle": "100% സൗജന്യവും സ്വകാര്യവും",
    "home.whyFreeDesc": "ടൂളുകൾക്ക് സൈൻ-അപ്പ് ആവശ്യമില്ല. നിങ്ങളുടെ ഡാറ്റ നിങ്ങളുടെ ഉപകരണത്തിൽ തന്നെ.",
    "home.whyLangTitle": "13 ഇന്ത്യൻ ഭാഷകൾ",
    "home.whyLangDesc": "ഹിന്ദി മുതൽ കന്നഡ, തമിഴ് മുതൽ അസമീസ് — സാമ്പത്തിക സാക്ഷരതയ്ക്ക് ഭാഷാ തടസ്സം ഉണ്ടാകരുത്.",
    "home.whyIndiaTitle": "ഇന്ത്യയ്ക്കായി നിർമ്മിച്ചത്",
    "home.whyIndiaDesc": "ഇന്ത്യൻ നികുതി രീതികൾ, SEBI നിയമങ്ങൾ, RBI നിരക്കുകൾ, UPI-യുഗ കടം നിർവ്വഹണം.",
    "home.whySathiTitle": "സാഥി ബുദ്ധിമത്ത",
    "home.whySathiDesc": "ഓരോ ടൂളിലും സന്ദർഭ-അധിഷ്ഠിത നിർദ്ദേശങ്ങൾ — സാമ്പത്തിക ബുദ്ധിയുള്ള സുഹൃത്ത് അടുത്തിരിക്കുന്നത് പോലെ.",
    "home.statTools": "സാമ്പത്തിക ടൂളുകൾ",
    "home.statLangs": "ഇന്ത്യൻ ഭാഷകൾ",
    "home.statFree": "എന്നും സൗജന്യം",
    "home.statPrivacy": "സ്വകാര്യത ആദ്യം",
    "home.footerDisclaimer2": "നൽകിയ ഡാറ്റ വിദ്യാഭ്യാസ ഉപയോഗത്തിന് മാത്രം. എല്ലാ പലിശ നിരക്കുകളും നികുതി നിയമങ്ങളും മാർച്ച് 2026 വരെ അപ്ഡേറ്റ്.",
    "home.footerIndian": "🇮🇳 100% ഇന്ത്യൻ ഉടമസ്ഥത — ഇന്ത്യൻ നികുതി രീതികൾ, റിയൽ എസ്റ്റേറ്റ് നിയമങ്ങൾ, UPI-അധിഷ്ഠിത കടം നിർവ്വഹണം.",
    "nav.stockResearch": "സ്റ്റോക്ക് റിസർച്ച്",
    "explore.title": "എല്ലാ ടൂളുകളും പര്യവേക്ഷണം ചെയ്യുക",
    "explore.subtitle": "നിങ്ങളുടെ സമ്പൂർണ്ണ സാമ്പത്തിക ടൂൾക്കിറ്റ് — കാൽക്കുലേറ്ററുകൾ, പ്ലാനറുകൾ & താരതമ്യ എൻജിനുകൾ",
    "explore.openTool": "ടൂൾ തുറക്കുക",
    "explore.toolCalc": "നിക്ഷേപ കാൽക്കുലേറ്ററുകൾ",
    "explore.toolCalcDesc": "SIP, ലം‌പ്‌സം, കൂടാതെ കൂടുതൽ നിക്ഷേപ കാൽക്കുലേറ്ററുകൾ",
    "explore.toolDebt": "കടം കൊലയാളി",
    "explore.toolDebtDesc": "കടം വേഗം അവസാനിപ്പിക്കാൻ സ്നോബോൾ vs അവലാഞ്ച് തന്ത്രങ്ങൾ",
    "explore.toolTaxSim": "നികുതി സിമുലേറ്റർ",
    "explore.toolTaxSimDesc": "പഴയ vs പുതിയ രീതിയിൽ നിങ്ങളുടെ നികുതി ബാധ്യത സിമുലേറ്റ് ചെയ്യുക",
    "explore.toolRealEstate": "റിയൽ എസ്റ്റേറ്റ് പ്ലാനർ",
    "explore.toolRealEstateDesc": "ബജറ്റ്, ROI സിമുലേറ്റർ, പ്രാപ്യത പരിശോധന",
    "explore.toolRentBuy": "വാടക vs വാങ്ങൽ വിശകലനം",
    "explore.toolRentBuyDesc": "15 വർഷ സമ്പത്ത് പ്രൊജക്ഷനോടെ വാടക vs വാങ്ങൽ താരതമ്യം",
    "explore.toolRetirement": "വിരമിക്കൽ ഘടികാരം",
    "explore.toolRetirementDesc": "വിരമിക്കൽ കോർപ്പസും മാസ SIP-ഉം ആസൂത്രണം ചെയ്യുക",
    "explore.toolCompare": "ഉൽപ്പന്ന താരതമ്യം",
    "explore.toolCompareDesc": "ക്രെഡിറ്റ് കാർഡുകൾ, സേവിംഗ്സ് അക്കൗണ്ടുകൾ & ആരോഗ്യ ഇൻഷുറൻസ് താരതമ്യം",
    "explore.toolEMI": "പ്രാപ്യത & EMI മെന്റർ",
    "explore.toolEMIDesc": "ശരിക്കും സാധ്യമാണോ? ക്യാഷ് vs EMI മറഞ്ഞ ചെലവുകൾ താരതമ്യം",
    "explore.toolInflation": "പണപ്പെരുപ്പ യാഥാർത്ഥ്യ യന്ത്രം",
    "explore.toolInflationDesc": "പണപ്പെരുപ്പം എങ്ങനെ നിശ്ശബ്ദമായി നിങ്ങളുടെ സമ്പാദ്യം തിന്നുന്നുവെന്ന് കാണുക",
    "explore.toolEmergency": "അടിയന്തര ഫണ്ട് ടെസ്റ്റർ",
    "explore.toolEmergencyDesc": "നിങ്ങളുടെ ആദർശ സേഫ്റ്റി നെറ്റ് കണക്കാക്കാൻ ക്വിസ്-അധിഷ്ഠിത സ്ട്രെസ് ടെസ്റ്റ്",
    "explore.toolChildFuture": "കുട്ടിയുടെ ഭാവി പ്ലാനർ",
    "explore.toolChildFutureDesc": "കുട്ടിയുടെ വിദ്യാഭ്യാസ സ്വപ്നത്തിന് SIP റിവേഴ്സ്-എൻജിനീയർ ചെയ്യുക",
    "explore.toolCreditCard": "ക്രെഡിറ്റ് കാർഡ് മാസ്റ്റർ",
    "explore.toolCreditCardDesc": "കടം കെണി സിമുലേറ്റർ, CIBIL പ്രെഡിക്ടർ & ട്രൂ റിവാർഡ് കാൽക്കുലേറ്റർ",
    "explore.toolMultiAsset": "മൾട്ടി-അസറ്റ് താരതമ്യം",
    "explore.toolMultiAssetDesc": "FD, സ്വർണ്ണം, റിയൽ എസ്റ്റേറ്റ്, ഇൻഡക്സ് ഫണ്ട് & സ്റ്റോക്ക് റിട്ടേണുകൾ താരതമ്യം ചെയ്യുക",
    "explore.toolStock": "സ്റ്റോക്ക് റിസർച്ച് ലാബ്",
    "explore.toolStockDesc": "ലൈവ് മാർക്കറ്റ് ഡാറ്റ, കമ്പനി അടിസ്ഥാനങ്ങൾ & TradingView ചാർട്ടുകൾ",
    "comp.bestFor": "ഇതിന് മികച്ചത്:",
    "comp.frequentFlyers": "പതിവ് യാത്രക്കാർ",
    "comp.onlineShoppers": "ഓൺലൈൻ ഷോപ്പർമാർ",
    // Premium redesign keys
    "hero.premiumHeadline": "നിങ്ങൾ ഓരോ ദിവസവും ധനികനാണോ അതോ ദരിദ്രനാണോ?",
    "hero.premiumSub": "30 സെക്കൻഡിനുള്ളിൽ കണ്ടെത്തുക. നിങ്ങളുടെ സാമ്പത്തിക ഭാവി, ദൃശ്യവൽക്കരിക്കപ്പെടുന്നു.",
    "hero.wealthCardTitle": "ഭാവി സമ്പത്ത് സിമുലേറ്റർ",
    "hero.monthlySavings": "പ്രതിമാസ നിക്ഷേപം",
    "hero.premiumCta": "സ്വാതന്ത്ര്യത്തിലേക്കുള്ള എൻ്റെ വഴി കാണിക്കുക",
    "cat.all": "എല്ലാ ഉപകരണങ്ങളും",
    "cat.debt": "കടരഹിത വഴി",
    "cat.invest": "നിക്ഷേപിക്കുക & വളർത്തുക",
    "cat.home": "ഒരു വീട് വാങ്ങുക",
    "cat.kids": "കുട്ടികൾക്കായി പദ്ധതി",
    "cat.tax": "നികുതി ലാഭിക്കുക",
    "tool.wealth.title": "സമ്പത്ത് എൻജിൻ",
    "tool.wealth.micro": "നിങ്ങളുടെ SIP എത്ര വേഗത്തിൽ വളരും? കൂട്ടുപലിശയുടെ മാന്ത്രിക ശക്തി കാണുക.",
    "tool.stock.title": "സ്റ്റോക്ക് ല্যাব",
    "tool.stock.micro": "നിങ്ങളുടെ പ്രിയപ്പെട്ട സ്റ്റോക്ക് ഒരു കുടുക്കാണോ? തത്സമയ ഡാറ്റ, ചാർട്ടുകൾ & അടിസ്ഥാനങ്ങൾ.",
    "tool.multiAsset.title": "മൾട്ടി-അസറ്റ് താരതമ്യം",
    "tool.multiAsset.micro": "FD vs സ്വർണ്ണം vs സ്റ്റോക്കുകൾ vs സൂചിക — 10 വർഷത്തിൽ ആര് വിജയിക്കും?",
    "tool.realEstate.title": "റിയൽ എസ്റ്റേറ്റ് പ്ലാനർ",
    "tool.realEstate.micro": "നിങ്ങളുടെ സ്വപ്ന ഭവനത്തിൻ്റെ യഥാർത്ഥ വില — EMI, സ്റ്റാമ്പ് ഡ്യൂട്ടി & മറഞ്ഞിരിക്കുന്ന ചാർജുകൾ.",
    "tool.rentBuy.title": "വാടക vs വാങ്ങുക",
    "tool.rentBuy.micro": "നിങ്ങളുടെ സ്വപ്ന ഭവനത്തിൻ്റെ പിന്നിലെ ഗണിതം. നിങ്ങൾ വാടകയ്ക്ക് എടുക്കണോ അതോ വാങ്ങണോ?",
    "tool.retirement.title": "വിരമിക്കൽ ക്ലോക്ക്",
    "tool.retirement.micro": "വിരമിക്കാൻ നിങ്ങൾക്ക് എത്ര പണം വേണം? നിങ്ങളുടെ മാന്ത്രിക സംഖ്യ കണ്ടെത്തുക.",
    "tool.taxSim.title": "നികുതി സിമുലേറ്റർ",
    "tool.taxSim.micro": "പഴയ vs പുതിയ ഭരണം — ഏതാണ് നിങ്ങൾക്ക് കൂടുതൽ ലാഭിക്കുന്നത്? തൽക്ഷണം കണ്ടെത്തുക.",
    "tool.debt.title": "കടരഹിത വഴി",
    "tool.debt.micro": "പലിശ അടയ്ക്കുന്നത് നിർത്തുക, ജീവിക്കാൻ തുടങ്ങുക. നിങ്ങളുടെ കടങ്ങൾ വേഗത്തിൽ ഇല്ലാതാക്കുക.",
    "tool.creditCard.title": "ക്രെഡിറ്റ് കാർഡ് മാസ്റ്റർ",
    "tool.creditCard.micro": "കടക്കെണി സിമുലേറ്റർ, CIBIL പ്രവചനം & യഥാർത്ഥ റിവാർഡ് കാൽക്കുലേറ്റർ.",
    "tool.childFuture.title": "കുട്ടിയുടെ ഭാവി",
    "tool.childFuture.micro": "നിങ്ങളുടെ കുട്ടിയുടെ വിദ്യാഭ്യാസ സ്വപ്നങ്ങൾക്കായി പ്രതിമാസ നിക്ഷേപം ആസൂത്രണം ചെയ്യുക.",
    "tool.canibuyit.title": "എനിക്ക് ഇത് വാങ്ങാൻ കഴിയുമോ?",
    "tool.canibuyit.micro": "നിങ്ങൾക്ക് അത് യഥാർത്ഥത്തിൽ താങ്ങാൻ കഴിയുമോ? എല്ലാ മറഞ്ഞിരിക്കുന്ന ചെലവുകളോടും കൂടി ക്യാഷ് vs EMI.",
    "tool.emergency.title": "അടിയന്തര ഫണ്ട്",
    "tool.emergency.micro": "നിങ്ങൾക്ക് യഥാർത്ഥത്തിൽ എത്ര സുരക്ഷാ വലയം വേണം? ഇപ്പോൾ കണ്ടെത്തുക.",
    "tool.inflation.title": "പണപ്പെരുപ്പ യന്ത്രം",
    "tool.inflation.micro": "₹100 ₹50 പോലെ തോന്നുന്നത് എന്തുകൊണ്ട്? നിങ്ങളുടെ സമ്പത്തിൻ്റെ നിശബ്ദ കള്ളൻ.",
    "tool.compare.title": "ഉൽപ്പന്ന താരതമ്യം",
    "tool.compare.micro": "ക്രെഡിറ്റ് കാർഡുകൾ, സേവിംഗ്സ് അക്കൗണ്ടുകൾ & ഇൻഷുറൻസ് എന്നിവ താരതമ്യം ചെയ്യുക.",
    "contact.title": "സഹായം ആവശ്യമുണ്ടോ? ഞങ്ങൾ ഇവിടെയുണ്ട്.",
    "contact.desc": "ചോദ്യങ്ങൾ, പ്രതികരണങ്ങൾ, അല്ലെങ്കിൽ 'ഹായ്' പറയാൻ ആഗ്രഹിക്കുന്നുണ്ടോ? എപ്പോൾ വേണമെങ്കിലും ബന്ധപ്പെടുക.",
    "nav.stockLab": "സ്റ്റോക്ക് ല্যাব",
    "nav.goalTracker": "ലക്ഷ്യങ്ങൾ",
    "nav.contact": "ബന്ധപ്പെടുക",
    "footer.terms": "ഉപയോഗ നിബന്ധനകൾ",
  },
  pa: {
    "home.toolkitTitle": "ਤੁਹਾਡਾ ਸੰਪੂਰਨ ਵਿੱਤੀ ਟੂਲਕਿੱਟ",
    "home.toolkitSub": "ਆਧੁਨਿਕ ਭਾਰਤੀ ਕਮਾਉਣ ਵਾਲਿਆਂ ਲਈ 12 ਸ਼ਕਤੀਸ਼ਾਲੀ ਟੂਲ — ਤੁਹਾਡੀ ਪਹਿਲੀ SIP ਤੋਂ ਰਿਟਾਇਰਮੈਂਟ ਕਾਰਪਸ ਤੱਕ.",
    "home.catInvest": "💰 ਨਿਵੇਸ਼ ਅਤੇ ਵਾਧਾ",
    "home.catPlan": "🏠 ਯੋਜਨਾ ਅਤੇ ਸੁਰੱਖਿਆ",
    "home.catTax": "📋 ਟੈਕਸ ਅਤੇ ਕਰਜ਼",
    "home.catLife": "🎯 ਜੀਵਨ ਦੇ ਪੜਾਅ",
    "home.viewAllTools": "ਸਾਰੇ ਟੂਲ ਵੇਖੋ",
    "home.whyTitle": "'ਸਾਥੀ' ਦਾ ਮਤਲਬ ਸਿਰਫ਼ ਇੱਕ ਟੂਲ ਨਹੀਂ",
    "home.whySub": "RupeeVikas ਸਿਰਫ਼ ਕੈਲਕੁਲੇਟਰ ਨਹੀਂ — ਇਹ ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਬੋਲਣ ਵਾਲਾ ਵਿੱਤੀ ਸਾਥੀ ਹੈ.",
    "home.statTools": "ਵਿੱਤੀ ਟੂਲ",
    "home.statLangs": "ਭਾਰਤੀ ਭਾਸ਼ਾਵਾਂ",
    "home.statFree": "ਹਮੇਸ਼ਾ ਮੁਫ਼ਤ",
    "home.statPrivacy": "ਗੋਪਨੀਯਤਾ ਪਹਿਲਾਂ",
    "nav.stockResearch": "ਸਟਾਕ ਰਿਸਰਚ",
    "explore.title": "ਸਾਰੇ ਟੂਲ ਖੋਜੋ",
    "explore.subtitle": "ਤੁਹਾਡਾ ਸੰਪੂਰਨ ਵਿੱਤੀ ਟੂਲਕਿੱਟ",
    "explore.openTool": "ਟੂਲ ਖੋਲੋ",
    // Premium redesign keys
    "hero.premiumHeadline": "ਕੀ ਤੁਸੀਂ ਹਰ ਰੋਜ਼ ਅਮੀਰ ਹੋ ਰਹੇ ਹੋ ਜਾਂ ਗਰੀਬ?",
    "hero.premiumSub": "30 ਸਕਿੰਟਾਂ ਵਿੱਚ ਪਤਾ ਲਗਾਓ। ਤੁਹਾਡਾ ਵਿੱਤੀ ਭਵਿੱਖ, ਕਲਪਨਾ ਕੀਤਾ ਗਿਆ।",
    "hero.wealthCardTitle": "ਭਵਿੱਖ ਸੰਪਤੀ ਸਿਮੂਲੇਟਰ",
    "hero.monthlySavings": "ਮਾਸਿਕ ਬੱਚਤ",
    "hero.premiumCta": "ਮੇਰੀ ਆਜ਼ਾਦੀ ਦਾ ਰਾਹ ਦਿਖਾਓ",
    "cat.all": "ਸਾਰੇ ਸੰਦ",
    "cat.debt": "ਕਰਜ਼-ਮੁਕਤ ਮਾਰਗ",
    "cat.invest": "ਨਿਵੇਸ਼ ਕਰੋ ਅਤੇ ਵਧੋ",
    "cat.home": "ਇੱਕ ਘਰ ਖਰੀਦੋ",
    "cat.kids": "ਬੱਚਿਆਂ ਲਈ ਯੋਜਨਾ",
    "cat.tax": "ਟੈਕਸ ਬਚਾਓ",
    "tool.wealth.title": "ਸੰਪਤੀ ਇੰਜਣ",
    "tool.wealth.micro": "ਤੁਹਾਡਾ SIP ਕਿੰਨੀ ਤੇਜ਼ੀ ਨਾਲ ਵਧ ਸਕਦਾ ਹੈ? ਚੱਕਰਵਰਤੀ ਦਾ ਜਾਦੂ ਕਾਰਵਾਈ ਵਿੱਚ ਵੇਖੋ।",
    "tool.stock.title": "ਸਟਾਕ ਲੈਬ",
    "tool.stock.micro": "ਕੀ ਤੁਹਾਡਾ ਪਸੰਦੀਦਾ ਸਟਾਕ ਇੱਕ ਜਾਲ ਹੈ? ਲਾਈਵ ਡਾਟਾ, ਚਾਰਟਸ ਅਤੇ ਬੁਨਿਆਦੀ ਗੱਲਾਂ।",
    "tool.multiAsset.title": "ਮਲਟੀ-ਐਸੇਟ ਤੁਲਨਾ",
    "tool.multiAsset.micro": "FD ਬਨਾਮ ਸੋਨਾ ਬਨਾਮ ਸਟਾਕ ਬਨਾਮ ਇੰਡੈਕਸ — 10 ਸਾਲਾਂ ਵਿੱਚ ਕੌਣ ਜਿੱਤਦਾ ਹੈ?",
    "tool.realEstate.title": "ਰੀਅਲ ਅਸਟੇਟ ਯੋਜਨਾਕਾਰ",
    "tool.realEstate.micro": "ਤੁਹਾਡੇ ਸੁਪਨਿਆਂ ਦੇ ਘਰ ਦੀ ਅਸਲ ਕੀਮਤ — EMI, ਸਟੈਂਪ ਡਿਊਟੀ ਅਤੇ ਲੁਕਵੇਂ ਖਰਚੇ।",
    "tool.rentBuy.title": "ਕਿਰਾਏ 'ਤੇ ਲਓ ਬਨਾਮ ਖਰੀਦੋ",
    "tool.rentBuy.micro": "ਤੁਹਾਡੇ ਸੁਪਨਿਆਂ ਦੇ ਘਰ ਪਿੱਛੇ ਗਣਿਤ। ਕੀ ਤੁਹਾਨੂੰ ਕਿਰਾਏ 'ਤੇ ਲੈਣਾ ਚਾਹੀਦਾ ਹੈ ਜਾਂ ਖਰੀਦਣਾ ਚਾਹੀਦਾ ਹੈ?",
    "tool.retirement.title": "ਰਿਟਾਇਰਮੈਂਟ ਘੜੀ",
    "tool.retirement.micro": "ਰਿਟਾਇਰ ਹੋਣ ਲਈ ਤੁਹਾਨੂੰ ਕਿੰਨੇ ਦੀ ਲੋੜ ਹੈ? ਆਪਣਾ ਜਾਦੂਈ ਨੰਬਰ ਲੱਭੋ।",
    "tool.taxSim.title": "ਟੈਕਸ ਸਿਮੂਲੇਟਰ",
    "tool.taxSim.micro": "ਪੁਰਾਣੀ ਬਨਾਮ ਨਵੀਂ ਪ੍ਰਣਾਲੀ — ਕਿਹੜੀ ਤੁਹਾਨੂੰ ਵਧੇਰੇ ਬਚਾਉਂਦੀ ਹੈ? ਤੁਰੰਤ ਪਤਾ ਲਗਾਓ।",
    "tool.debt.title": "ਕਰਜ਼-ਮੁਕਤ ਮਾਰਗ",
    "tool.debt.micro": "ਵਿਆਜ ਦੇਣਾ ਬੰਦ ਕਰੋ, ਜੀਣਾ ਸ਼ੁਰੂ ਕਰੋ। ਆਪਣੇ ਕਰਜ਼ਿਆਂ ਨੂੰ ਤੇਜ਼ੀ ਨਾਲ ਕੁਚਲੋ।",
    "tool.creditCard.title": "ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਮਾਸਟਰ",
    "tool.creditCard.micro": "ਕਰਜ਼ਾ ਜਾਲ ਸਿਮੂਲੇਟਰ, CIBIL ਭਵਿੱਖਬਾਣੀ ਅਤੇ ਅਸਲ ਇਨਾਮ ਕੈਲਕੁਲੇਟਰ।",
    "tool.childFuture.title": "ਬੱਚੇ ਦਾ ਭਵਿੱਖ",
    "tool.childFuture.micro": "ਤੁਹਾਡੇ ਬੱਚੇ ਦੇ ਸਿੱਖਿਆ ਦੇ ਸੁਪਨਿਆਂ ਲਈ ਮਾਸਿਕ ਬੱਚਤ ਦੀ ਯੋਜਨਾ ਬਣਾਓ।",
    "tool.canibuyit.title": "ਕੀ ਮੈਂ ਇਹ ਖਰੀਦ ਸਕਦਾ ਹਾਂ?",
    "tool.canibuyit.micro": "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸਨੂੰ ਬਰਦਾਸ਼ਤ ਕਰ ਸਕਦੇ ਹੋ? ਸਾਰੇ ਲੁਕਵੇਂ ਖਰਚਿਆਂ ਨਾਲ ਨਕਦ ਬਨਾਮ EMI।",
    "tool.emergency.title": "ਐਮਰਜੈਂਸੀ ਫੰਡ",
    "tool.emergency.micro": "ਤੁਹਾਨੂੰ ਅਸਲ ਵਿੱਚ ਕਿੰਨੀ ਸੁਰੱਖਿਆ ਜਾਲ ਦੀ ਲੋੜ ਹੈ? ਹੁਣੇ ਪਤਾ ਲਗਾਓ।",
    "tool.inflation.title": "ਮਹਿੰਗਾਈ ਮਸ਼ੀਨ",
    "tool.inflation.micro": "₹100 ₹50 ਵਰਗਾ ਕਿਉਂ ਲੱਗਦਾ ਹੈ। ਤੁਹਾਡੀ ਦੌਲਤ ਦਾ ਚੁੱਪ ਚੋਰ।",
    "tool.compare.title": "ਉਤਪਾਦ ਦੀ ਤੁਲਨਾ ਕਰੋ",
    "tool.compare.micro": "ਕ੍ਰੈਡਿਟ ਕਾਰਡ, ਬਚਤ ਖਾਤੇ ਅਤੇ ਬੀਮੇ ਦੀ ਨਾਲ-ਨਾਲ ਤੁਲਨਾ ਕਰੋ।",
    "contact.title": "ਮਦਦ ਦੀ ਲੋੜ ਹੈ? ਅਸੀਂ ਇੱਥੇ ਹਾਂ।",
    "contact.desc": "ਸਵਾਲ, ਫੀਡਬੈਕ, ਜਾਂ ਸਿਰਫ਼ 'ਹੈਲੋ' ਕਹਿਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਕਿਸੇ ਵੀ ਸਮੇਂ ਸੰਪਰਕ ਕਰੋ।",
    "nav.stockLab": "ਸਟਾਕ ਲੈਬ",
    "nav.goalTracker": "ਟੀਚੇ",
    "nav.contact": "ਸੰਪਰਕ",
    "nav.taxPlanner": "ਟੈਕਸ ਯੋਜਨਾ",
    "nav.propertyPlanner": "ਜਾਇਦਾਦ",
    "footer.terms": "ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ",
  },
  or: {
    "home.toolkitTitle": "ଆପଣଙ୍କ ସମ୍ପୂର୍ଣ୍ଣ ଆର୍ଥିକ ଟୁଲ୍‌କିଟ୍",
    "home.toolkitSub": "ଆଧୁନିକ ଭାରତୀୟ ରୋଜଗାର କରୁଥିବା ଲୋକଙ୍କ ପାଇଁ 12 ଶକ୍ତିଶାଳୀ ଟୁଲ୍ — ଆପଣଙ୍କ ପ୍ରଥମ SIP ଠାରୁ ଅବସର କର୍ପସ ପର୍ଯ୍ୟନ୍ତ.",
    "home.catInvest": "💰 ନିବେଶ ଓ ବୃଦ୍ଧି",
    "home.catPlan": "🏠 ଯୋଜନା ଓ ସୁରକ୍ଷା",
    "nav.taxPlanner": "କର ଯୋଜନା",
    "nav.propertyPlanner": "ସମ୍ପତ୍ତି",
    "home.catTax": "📋 ଟ୍ୟାକ୍ସ ଓ ଋଣ",
    "home.viewAllTools": "ସବୁ ଟୁଲ୍ ଦେଖନ୍ତୁ",
    "home.whyTitle": "'ସାଥୀ' ମାନେ କେବଳ ଏକ ଟୁଲ୍ ନୁହେଁ",
    "home.whySub": "RupeeVikas କେବଳ କ୍ୟାଲ୍‌କୁଲେଟର ନୁହେଁ — ଆପଣଙ୍କ ଭାଷାରେ କଥା କହୁଥିବା ଆର୍ଥିକ ସାଥୀ.",
    "home.statTools": "ଆର୍ଥିକ ଟୁଲ୍",
    "home.statLangs": "ଭାରତୀୟ ଭାଷା",
    "home.statFree": "ସବୁଦିନ ମାଗଣା",
    "home.statPrivacy": "ଗୋପନୀୟତା ପ୍ରଥମ",
    "nav.stockResearch": "ଷ୍ଟକ୍ ରିସର୍ଚ",
    "explore.title": "ସବୁ ଟୁଲ୍ ଅନୁସନ୍ଧାନ କରନ୍ତୁ",
    "explore.subtitle": "ଆପଣଙ୍କ ସମ୍ପୂର୍ଣ୍ଣ ଆର୍ଥିକ ଟୁଲ୍‌କିଟ୍",
    "explore.openTool": "ଟୁଲ୍ ଖୋଲନ୍ତୁ",
    // Premium redesign keys
    "hero.premiumHeadline": "ଆପଣ ପ୍ରତିଦିନ ଧନୀ ହେଉଛନ୍ତି ନା ଗରିବ?",
    "hero.premiumSub": "30 ସେକେଣ୍ଡରେ ଜାଣନ୍ତୁ। ଆପଣଙ୍କର ଆର୍ଥିକ ଭବିଷ୍ୟତ, ଦୃଶ୍ୟମାନ ହୋଇଛି।",
    "hero.wealthCardTitle": "ଭବିଷ୍ୟତ ସମ୍ପତ୍ତି ସିମୁଲେଟର",
    "hero.monthlySavings": "ମାସିକ ସଞ୍ଚୟ",
    "hero.premiumCta": "ମୋର ସ୍ୱାଧୀନତାର ପଥ ଦେଖାନ୍ତୁ",
    "cat.all": "ସମସ୍ତ ଉପକରଣ",
    "cat.debt": "ଋଣମୁକ୍ତ ପଥ",
    "cat.invest": "ନିବେଶ କରନ୍ତୁ ଏବଂ ବଢାନ୍ତୁ",
    "cat.home": "ଏକ ଘର କିଣନ୍ତୁ",
    "cat.kids": "ପିଲାମାନଙ୍କ ପାଇଁ ଯୋଜନା",
    "cat.tax": "କର ବଞ୍ଚାନ୍ତୁ",
    "tool.wealth.title": "ସମ୍ପତ୍ତି ଇଞ୍ଜିନ",
    "tool.wealth.micro": "ଆପଣଙ୍କର SIP କେତେ ଶୀଘ୍ର ବଢିପାରିବ? ଚକ୍ରବୃଦ୍ଧିର ଯାଦୁ କାର୍ଯ୍ୟରେ ଦେଖନ୍ତୁ।",
    "tool.stock.title": "ଷ୍ଟକ ଲ୍ୟାବ",
    "tool.stock.micro": "ଆପଣଙ୍କର ପ୍ରିୟ ଷ୍ଟକ ଏକ ଜାଲ କି? ଲାଇଭ୍ ଡାଟା, ଚାର୍ଟ ଏବଂ ମୌଳିକ ବିଷୟବସ୍ତୁ।",
    "tool.multiAsset.title": "ମଲ୍ଟି-ଆସେଟ ତୁଳନା",
    "tool.multiAsset.micro": "FD ବନାମ ସୁନା ବନାମ ଷ୍ଟକ ବନାମ ଇଣ୍ଡେକ୍ସ — 10 ବର୍ଷରେ କିଏ ଜିତେ?",
    "tool.realEstate.title": "ରିଏଲ ଇଷ୍ଟେଟ ପ୍ଲାନର",
    "tool.realEstate.micro": "ଆପଣଙ୍କର ସ୍ୱପ୍ନ ଘରର ପ୍ରକୃତ ମୂଲ୍ୟ — EMI, ଷ୍ଟାମ୍ପ୍ ଡ୍ୟୁଟି ଏବଂ ଲୁକାୟିତ ଶୁଳ୍କ।",
    "tool.rentBuy.title": "ଭଡା ବନାମ କିଣନ୍ତୁ",
    "tool.rentBuy.micro": "ଆପଣଙ୍କ ସ୍ୱପ୍ନ ଘର ପଛରେ ଥିବା ଗଣିତ। ଆପଣ ଭଡା ନେବା ଉଚିତ ନା କିଣିବା ଉଚିତ?",
    "tool.retirement.title": "ଅବସର ଘଣ୍ଟା",
    "tool.retirement.micro": "ଅବସର ନେବା ପାଇଁ ଆପଣଙ୍କୁ କେତେ ଦରକାର? ଆପଣଙ୍କର ଯାଦୁକରୀ ସଂଖ୍ୟା ଖୋଜନ୍ତୁ।",
    "tool.taxSim.title": "କର ସିମୁଲେଟର",
    "tool.taxSim.micro": "ପୁରୁଣା ବନାମ ନୂଆ ଶାସନ — କେଉଁଟି ଆପଣଙ୍କୁ ଅଧିକ ବଞ୍ଚାଏ? ତୁରନ୍ତ ଜାଣନ୍ତୁ।",
    "tool.debt.title": "ଋଣମୁକ୍ତ ପଥ",
    "tool.debt.micro": "ସୁଧ ଦେବା ବନ୍ଦ କରନ୍ତୁ, ରହିବା ଆରମ୍ଭ କରନ୍ତୁ। ଆପଣଙ୍କର ଋଣକୁ ଶୀଘ୍ର ଚୂର୍ଣ୍ଣ କରନ୍ତୁ।",
    "tool.creditCard.title": "କ୍ରେଡିଟ କାର୍ଡ ମାଷ୍ଟର",
    "tool.creditCard.micro": "ଋଣ ଜାଲ ସିମୁଲେଟର, CIBIL ଭବିଷ୍ୟବାଣୀ ଏବଂ ପ୍ରକୃତ ପୁରସ୍କାର କାଲକୁଲେଟର।",
    "tool.childFuture.title": "ଶିଶୁର ଭବିଷ୍ୟତ",
    "tool.childFuture.micro": "ଆପଣଙ୍କ ଶିଶୁର ଶିକ୍ଷା ସ୍ୱପ୍ନ ପାଇଁ ମାସିକ ସଞ୍ଚୟ ଯୋଜନା କରନ୍ତୁ।",
    "tool.canibuyit.title": "ମୁଁ ଏହା କିଣି ପାରିବି କି?",
    "tool.canibuyit.micro": "ଆପଣ ଏହାକୁ ପ୍ରକୃତରେ ସାମର୍ଥ୍ୟ କରିପାରିବେ କି? ସମସ୍ତ ଲୁକାୟିତ ଖର୍ଚ୍ଚ ସହିତ ନଗଦ ବନାମ EMI।",
    "tool.emergency.title": "ଜରୁରୀକାଳୀନ ପାଣ୍ଠି",
    "tool.emergency.micro": "ଆପଣଙ୍କୁ ପ୍ରକୃତରେ କେତେ ସୁରକ୍ଷା ଜାଲ ଦରକାର? ବର୍ତ୍ତମାନ ଜାଣନ୍ତୁ।",
    "tool.inflation.title": "ମୁଦ୍ରାସ୍ଫୀତି ମେସିନ",
    "tool.inflation.micro": "₹100 କାହିଁକି ₹50 ପରି ଲାଗେ। ଆପଣଙ୍କ ସମ୍ପତ୍ତିର ନୀରବ ଚୋର।",
    "tool.compare.title": "ଉତ୍ପାଦ ତୁଳନା",
    "tool.compare.micro": "କ୍ରେଡିଟ କାର୍ଡ, ସଞ୍ଚୟ ଆକାଉଣ୍ଟ ଏବଂ ବୀମାକୁ ସମାନ ଭାବରେ ତୁଳନା କରନ୍ତୁ।",
    "contact.title": "ସାହାଯ୍ୟ ଦରକାର? ଆମେ ଏଠାରେ ଅଛୁ।",
    "contact.desc": "ପ୍ରଶ୍ନ, ମତାମତ, କିମ୍ବା କେବଳ 'ହାଏ' କହିବାକୁ ଚାହୁଁଛନ୍ତି? ଯେକୌଣସି ସମୟରେ ଯୋଗାଯୋଗ କରନ୍ତୁ।",
    "nav.stockLab": "ଷ୍ଟକ ଲ୍ୟାବ",
    "nav.goalTracker": "ଲକ୍ଷ୍ୟ",
    "nav.contact": "ଯୋଗାଯୋଗ",
    "footer.terms": "ବ୍ୟବହାରର ସର୍ତ୍ତାବଳୀ",
  },
  as: {
    "home.toolkitTitle": "আপোনাৰ সম্পূৰ্ণ বিত্তীয় টুলকিট",
    "home.toolkitSub": "আধুনিক ভাৰতীয় উপাৰ্জনকাৰীসকলৰ বাবে ১২ টা শক্তিশালী সঁজুলি — আপোনাৰ প্ৰথম SIP ৰ পৰা অৱসৰকালীন কৰ্পাছ লৈ.",
    "home.catInvest": "💰 বিনিয়োগ আৰু বৃদ্ধি",
    "home.catPlan": "🏠 পৰিকল্পনা আৰু সুৰক্ষা",
    "nav.taxPlanner": "কৰ পৰিকল্পক",
    "nav.propertyPlanner": "সম্পত্তি",
    "home.catTax": "📋 কৰ আৰু ঋণ",
    "home.catLife": "🎯 জীৱনৰ পৰ্যায়সমূহ",
    "home.viewAllTools": "সকলো সঁজুলি চাওক",
    "home.whyTitle": "'সাথী' মানে কেৱল এটা সঁজুলি নহয়",
    "home.whySub": "RupeeVikas কেৱল কেলকুলেটৰ নহয় — আপোনাৰ ভাষাত কথা কোৱা বিত্তীয় সংগী.",
    "home.statTools": "বিত্তীয় সঁজুলি",
    "home.statLangs": "ভাৰতীয় ভাষা",
    "home.statFree": "সদায় বিনামূলীয়া",
    "home.statPrivacy": "গোপনীয়তা প্ৰথম",
    "nav.stockResearch": "ষ্টক ৰিচাৰ্চ",
    "explore.title": "সকলো সঁজুলি অন্বেষণ কৰক",
    "explore.subtitle": "আপোনাৰ সম্পূৰ্ণ বিত্তীয় টুলকিট",
    "explore.openTool": "সঁজুলি খোলক",
    // Premium redesign keys
    "hero.premiumHeadline": "আপুনি প্ৰতিদিনে ধনী হৈছে নে দুখীয়া হৈছে?",
    "hero.premiumSub": "30 ছেকেণ্ডত বিচাৰক। আপোনাৰ বিত্তীয় ভৱিষ্যত, দৃশ্যাংকন কৰা হৈছে।",
    "hero.wealthCardTitle": "ভৱিষ্যত সম্পদ চিমুলেটৰ",
    "hero.monthlySavings": "মাহিলী সঞ্চয়",
    "hero.premiumCta": "স্বাধীনতাৰ মোৰ পথ দেখুৱাওক",
    "cat.all": "সকলো সঁজুলি",
    "cat.debt": "ঋণ-মুক্ত পথ",
    "cat.invest": "বিনিয়োগ কৰক আৰু বৃদ্ধি কৰক",
    "cat.home": "এটা ঘৰ কিনক",
    "cat.kids": "শিশুৰ বাবে পৰিকল্পনা",
    "cat.tax": "কৰ বচাওক",
    "tool.wealth.title": "সম্পদ ইঞ্জিন",
    "tool.wealth.micro": "আপোনাৰ SIP কিমান বেগেৰে বৃদ্ধি পাব পাৰে? চক্ৰবৃদ্ধাৰ যাদু কাৰ্যত চাওক।",
    "tool.stock.title": "ষ্টক লেব",
    "tool.stock.micro": "আপোনাৰ প্ৰিয় স্টক এটা ফন্দি নেকি? লাইভ ডেটা, চাৰ্ট আৰু মৌলিক বিষয়বোৰ।",
    "tool.multiAsset.title": "মাল্টি-এচেট তুলনা",
    "tool.multiAsset.micro": "FD বনাম সোণ বনাম স্টক বনাম সূচক — 10 বছৰত কোনে জিকা?",
    "tool.realEstate.title": "ৰিয়েল এষ্টেট পৰিকল্পনাকাৰী",
    "tool.realEstate.micro": "আপোনাৰ সপোনৰ ঘৰৰ প্ৰকৃত মূল্য — EMI, ষ্টাম্প ড্যুটি আৰু গোপন শুল্ক।",
    "tool.rentBuy.title": "ভাৰা বনাম কিনক",
    "tool.rentBuy.micro": "আপোনাৰ সপোনৰ ঘৰৰ পিছৰ গণিত। আপুনি ভাৰা লব লাগে নে কিনিব লাগে?",
    "tool.retirement.title": "অৱসৰ ঘড়ী",
    "tool.retirement.micro": "অৱসৰ লবলৈ আপোনাক কিমান লাগে? আপোনাৰ যাদুকৰী সংখ্যা বিচাৰক।",
    "tool.taxSim.title": "কৰ চিমুলেটৰ",
    "tool.taxSim.micro": "পুৰণি বনাম নতুন ব্যৱস্থা — কোনটোৱে আপোনাক অধিক বচায়? ততাতৈয়াকৈ বিচাৰক।",
    "tool.debt.title": "ঋণ-মুক্ত পথ",
    "tool.debt.micro": "সুদ দিয়া বন্ধ কৰক, জীয়াই থাকিব। আপোনাৰ ঋণবোৰ সোনকালে শেষ কৰক।",
    "tool.creditCard.title": "ক্ৰেডিট কাৰ্ড মাষ্টাৰ",
    "tool.creditCard.micro": "ঋণ ফন্দি চিমুলেটৰ, CIBIL ভৱিষ্যদ্বক্তা আৰু প্ৰকৃত পুৰস্কাৰ কেলকুলেটৰ।",
    "tool.childFuture.title": "শিশুৰ ভৱিষ্যত",
    "tool.childFuture.micro": "আপোনাৰ শিশুৰ শিক্ষাৰ সপোনৰ বাবে মাহিলী সঞ্চয়ৰ পৰিকল্পনা কৰক।",
    "tool.canibuyit.title": "মই এইটো কিনিব পাৰিম নে?",
    "tool.canibuyit.micro": "আপুনি সঁচাকৈয়ে ইয়াৰ সামৰ্থ্য কৰিব পাৰিবনে? সকলো গোপন খৰচৰ সৈতে নগদ বনাম EMI।",
    "tool.emergency.title": "জৰুৰীকালীন পুঁজি",
    "tool.emergency.micro": "আপোনাক সঁচাকৈয়ে কিমান সুৰক্ষা জালৰ প্ৰয়োজন? এতিয়াই বিচাৰক।",
    "tool.inflation.title": "মুদ্ৰাস্ফীতি মেচিন",
    "tool.inflation.micro": "₹100 ₹50 যেন কিয় লাগে। আপোনাৰ সম্পদৰ নীৰৱ চোৰ।",
    "tool.compare.title": "সামগ্ৰী তুলনা",
    "tool.compare.micro": "ক্ৰেডিট কাৰ্ড, সঞ্চয় একাউণ্ট আৰু বীমাৰ ওচৰা-ওচৰি তুলনা কৰক।",
    "contact.title": "সহায় লাগে? আমি ইয়াত আছোঁ।",
    "contact.desc": "প্ৰশ্ন, মতামত, বা কেৱল 'হাই' ক’ব বিচাৰে? যিকোনো সময়তে যোগাযোগ কৰক।",
    "nav.stockLab": "ষ্টক লেব",
    "nav.goalTracker": "লক্ষ্যসমূহ",
    "nav.contact": "যোগাযোগ",
    "footer.terms": "ব্যৱহাৰৰ চৰ্তাৱলী",
  },
  ur: {
    "home.toolkitTitle": "آپ کی مکمل مالیاتی ٹول کٹ",
    "home.toolkitSub": "جدید ہندوستانی کمانے والوں کے لیے 12 طاقتور ٹولز — آپ کی پہلی SIP سے ریٹائرمنٹ کارپس تک.",
    "home.catInvest": "💰 سرمایہ کاری اور ترقی",
    "home.catPlan": "🏠 منصوبہ بندی اور تحفظ",
    "home.catTax": "📋 ٹیکس اور قرض",
    "home.catLife": "🎯 زندگی کے مراحل",
    "home.viewAllTools": "تمام ٹولز دیکھیں",
    "home.whyTitle": "'ساتھی' صرف ایک ٹول نہیں",
    "home.whySub": "RupeeVikas صرف کیلکولیٹر نہیں — آپ کی زبان میں بات کرنے والا مالیاتی ساتھی ہے.",
    "home.statTools": "مالیاتی ٹولز",
    "home.statLangs": "ہندوستانی زبانیں",
    "home.statFree": "ہمیشہ مفت",
    "home.statPrivacy": "پرائیویسی پہلے",
    "nav.stockResearch": "اسٹاک ریسرچ",
    "explore.title": "تمام ٹولز دریافت کریں",
    "explore.subtitle": "آپ کی مکمل مالیاتی ٹول کٹ",
    "explore.openTool": "ٹول کھولیں",
    // Premium redesign keys
    "hero.premiumHeadline": "کیا آپ ہر دن امیر ہو رہے ہیں یا غریب؟",
    "hero.premiumSub": "30 سیکنڈ میں جانیں۔ آپ کا مالی مستقبل، تصور کیا گیا۔",
    "hero.wealthCardTitle": "مستقبل دولت سمیلیٹر",
    "hero.monthlySavings": "ماہانہ بچت",
    "hero.premiumCta": "آزادی کا میرا راستہ دکھائیں",
    "cat.all": "تمام اوزار",
    "cat.debt": "قرض سے پاک راستہ",
    "cat.invest": "سرمایہ کاری کریں اور بڑھائیں",
    "cat.home": "ایک گھر خریدیں",
    "cat.kids": "بچوں کے لیے منصوبہ",
    "cat.tax": "ٹیکس بچائیں",
    "tool.wealth.title": "دولت انجن",
    "tool.wealth.micro": "آپ کا SIP کتنی تیزی سے بڑھ سکتا ہے؟ کمپاؤنڈنگ کا جادو دیکھیں عمل میں۔",
    "tool.stock.title": "اسٹاک لیب",
    "tool.stock.micro": "کیا آپ کا پسندیدہ اسٹاک پھندا ہے؟ لائیو ڈیٹا، چارٹس اور بنیادی باتیں",
    "tool.multiAsset.title": "ملٹی-ایسٹ موازنہ",
    "tool.multiAsset.micro": "FD بمقابلہ سونا بمقابلہ اسٹاک بمقابلہ انڈیکس — 10 سال میں کون جیتتا ہے؟",
    "tool.realEstate.title": "ریئل اسٹیٹ پلانر",
    "tool.realEstate.micro": "آپ کے خوابوں کے گھر کی حقیقی لاگت — EMI، سٹیمپ ڈیوٹی اور پوشیدہ چارجز۔",
    "tool.rentBuy.title": "کرایہ بمقابلہ خریدیں",
    "tool.rentBuy.micro": "آپ کے خوابوں کے گھر کے پیچھے کا حساب۔ کیا آپ کو کرایہ پر لینا چاہیے یا خریدنا چاہیے؟",
    "tool.retirement.title": "ریٹائرمنٹ کلاک",
    "tool.retirement.micro": "ریٹائر ہونے کے لیے آپ کو کتنے پیسے کی ضرورت ہے؟ اپنا جادوئی نمبر تلاش کریں۔",
    "tool.taxSim.title": "ٹیکس سمیلیٹر",
    "tool.taxSim.micro": "پرانی بمقابلہ نئی حکومت — کون سی آپ کو زیادہ بچاتی ہے؟ فوری معلوم کریں۔",
    "tool.debt.title": "قرض سے پاک راستہ",
    "tool.debt.micro": "سود دینا بند کریں، جینا شروع کریں۔ اپنے قرضوں کو تیزی سے کچل دیں۔",
    "tool.creditCard.title": "کریڈٹ کارڈ ماسٹر",
    "tool.creditCard.micro": "قرض کے جال کا سمیلیٹر، CIBIL پیشن گوئی اور حقیقی انعام کا کیلکولیٹر۔",
    "tool.childFuture.title": "بچے کا مستقبل",
    "tool.childFuture.micro": "آپ کے بچے کی تعلیمی خوابوں کے لیے ماہانہ بچت کی منصوبہ بندی کریں۔",
    "tool.canibuyit.title": "کیا میں یہ خرید سکتا ہوں?",
    "tool.canibuyit.micro": "کیا آپ اسے واقعی برداشت کر سکتے ہیں؟ تمام پوشیدہ اخراجات کے ساتھ نقد بمقابلہ EMI۔",
    "tool.emergency.title": "ایمرجنسی فنڈ",
    "tool.emergency.micro": "آپ کو واقعی کتنی حفاظتی جال کی ضرورت ہے؟ ابھی معلوم کریں۔",
    "tool.inflation.title": "افراط زر مشین",
    "tool.inflation.micro": "₹100 کیوں ₹50 جیسا لگتا ہے۔ آپ کی دولت کا خاموش چور۔",
    "tool.compare.title": "پروڈکٹ کا موازنہ",
    "tool.compare.micro": "کریڈٹ کارڈز، بچت کھاتوں اور بیمہ کا پہلو بہ پہلو موازنہ کریں۔",
    "contact.title": "مدد چاہیے؟ ہم یہاں ہیں۔",
    "contact.desc": "سوالات، رائے، یا صرف سلام کہنا چاہتے ہیں؟ کسی بھی وقت رابطہ کریں۔",
    "nav.stockLab": "اسٹاک لیب",
    "nav.goalTracker": "اہداف",
    "nav.contact": "رابطہ",
    "footer.terms": "استعمال کی شرائط",
    "nav.taxPlanner": "ٹیکس پلانر",
    "nav.propertyPlanner": "جائیداد",
  },
};
